// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Listing Styles */

/* ================================================================== */
/* Palette tokens                                                     */
/*                                                                    */
/* All colors used below are declared here so a single edit re-skins  */
/* the listing. --listing-* covers the original SENAITE workflow      */
/* state palette; --sf-* covers the Saved Filters + Column Header     */
/* chrome added later.                                                */
/* ================================================================== */

:root {
  /* surfaces + neutrals */
  --sf-bg:           #fff;
  --sf-bg-subtle:    #fafbfc;   /* column filter strip                */
  --sf-bg-hover:     #f1f3f5;   /* neutral hover                      */
  --sf-bg-row-hover: #f7f9fc;   /* preset row hover                   */
  --sf-bg-edit-row:  #f4f7fb;   /* inline editor row tint             */
  --sf-hairline:     #eef0f3;   /* internal dividers                  */
  --sf-divider:      #f3f4f6;   /* between rows                       */
  --sf-border:       #ced4da;   /* default control border             */
  --sf-border-soft:  #d8dde3;   /* softer input border                */
  --sf-border-card:  #e3e6ea;   /* menu card border                   */
  --sf-fg:           #212529;   /* body text                          */
  --sf-fg-muted:     #495057;   /* secondary text                     */
  --sf-fg-mutest:    #6c757d;   /* tertiary text                      */
  --sf-fg-faint:     #adb5bd;   /* icon idle                          */
  --sf-fg-faintest:  #ced4da;   /* inactive sort arrow on active col  */
  --sf-fg-empty:     #868e96;   /* empty-state copy                   */

  /* accent — SENAITE blue */
  --sf-accent:        #0b5ed7;
  --sf-accent-border: #9ec5ff;
  --sf-accent-soft:   #eaf3ff;
  --sf-accent-focus:  #6ea8fe;
  --sf-accent-input-border: #c5d6ee;
  --sf-accent-overlay-08:  rgba(11, 94, 215, .08);
  --sf-accent-overlay-15:  rgba(11, 94, 215, .15);
  --sf-accent-overlay-20:  rgba(0, 123, 255, .20);

  /* success — preset applied */
  --sf-success:        #198754;
  --sf-success-border: #a3d9b1;
  --sf-success-soft:   #e9f7ef;
  --sf-success-row:    #f0f8f3;
  --sf-success-row-hover: #e3f1e9;

  /* warning — default-preset gold (star) + dirty amber */
  --sf-warning-star:        #e0a800;
  --sf-warning-star-hover:  #c69400;
  --sf-warning-tag-bg:      #fff4c2;  /* "auto" tag        */
  --sf-warning-tag-fg:      #8a6d00;
  --sf-warning-row:         #fbfaf3;  /* default-preset row tint */
  --sf-warning-row-hover:   #f7f3e3;
  --sf-warning-row-both:    #f6f7e9;  /* applied + default */
  --sf-dirty-row:           #fff7e9;
  --sf-dirty-row-hover:     #fdeed2;
  --sf-dirty-tag-bg:        #ffe9c2;  /* "modified" tag    */
  --sf-dirty-tag-fg:        #8a4a00;

  /* danger — destructive */
  --sf-danger:        #c92a2a;
  --sf-danger-border: #e6b4b4;
  --sf-danger-soft:   #fdf3f3;
  --sf-danger-hairline: #f3dada;
  --sf-danger-fg:     #842029;
  --sf-danger-fg-strong: #4d0a0a;
  --sf-danger-overlay-08: rgba(201, 42, 42, .08);

  /* shadows + animation */
  --sf-shadow-card:
    0 1px 2px  rgba(16, 24, 40, .04),
    0 8px 24px rgba(16, 24, 40, .08);
  --sf-shadow-overlay: rgba(0, 0, 0, .05);
  --sf-radius-card: 8px;
  --sf-radius-pill: 999px;
  --sf-trans-fast: .12s ease;

  /* ---------------------------------------------------------------- */
  /* SENAITE workflow / table palette                                 */
  /* Original swatches sourced from mdbootstrap.com/css/colors/.       */
  /* ---------------------------------------------------------------- */

  /* table chrome */
  --listing-border-table:        #ddd;
  --listing-border-divider:      #e3e3e3;
  --listing-border-strong:       #000;
  --listing-bg-muted:            #f5f5f5;
  --listing-bg-row-alt:          #f9f9f9;
  --listing-bg-th-hover:         #ccc;
  --listing-fg-toggle:           #555;
  --listing-fg-category:         #3E4551;
  --listing-category-bg:         rgba(96, 125, 139, .1);
  --listing-overlay-loader:      rgba(255, 255, 255, .6);

  /* progress bar */
  --listing-progress-fg:         #f5f5f5;
  --listing-progress-bg:         #33b5e5;
  --listing-progress-bg-disabled:#c9c9c9;

  /* workflow states — border + row-hover overlay per state           */
  --listing-state-sample-due:           #ffff8d;
  --listing-state-sample-due-hover:     rgba(255, 235, 59, .1);

  --listing-state-sample-received:        #a1887f;
  --listing-state-sample-received-hover:  rgba(121, 85, 72, .1);

  --listing-state-retracted:        #ff6f00;
  --listing-state-retracted-hover:  rgba(255, 152, 0, .1);
  --listing-state-retracted-bg:     #eceff1;
  --listing-state-retracted-fg:     #78909c;

  --listing-state-to-be-verified:        #18ffff;
  --listing-state-to-be-verified-hover:  rgba(0, 188, 212, .1);

  --listing-state-verified:        #0091ea;
  --listing-state-verified-hover:  rgba(3, 169, 244, .2);

  --listing-state-published:        #00c853;
  --listing-state-published-hover:  rgba(76, 175, 80, .2);

  --listing-state-invalid:        #e65100;
  --listing-state-invalid-hover:  rgba(244, 67, 54, .2);

  --listing-state-rejected:        #abc;
  --listing-state-rejected-hover:  #abc;

  --listing-state-cancelled:        #000;
  --listing-state-cancelled-hover:  rgba(0, 0, 0, .1);

  --listing-state-inactive-border:  #616161;

  /* Bootstrap-matching tokens for the searchable-select dropdown and
     the column-filter-row strip (pre-existing styles). */
  --listing-bs-primary:           #007bff;
  --listing-bs-primary-dark:      #0056b3;
  --listing-bs-secondary:         #6c757d;
  --listing-bs-border:            #ced4da;
  --listing-bs-border-soft:       #dee2e6;
  --listing-bs-bg-light:          #f8f9fa;
  --listing-bs-bg-hover:          #e9ecef;
  --listing-shadow-dropdown:      0 4px 6px rgba(0, 0, 0, .1);
}


/* Colors taken from https://mdbootstrap.com/css/colors/ */
.ajax-contents-table tbody tr { border-left:2px solid var(--listing-border-table); }
.ajax-contents-table tbody tr:last-child { border-bottom:1px solid var(--listing-border-table); }

/* state sample_due */
.ajax-contents-table tr.state-sample_due { border-left:2px solid var(--listing-state-sample-due) !important; }
.ajax-contents-table td.result.state-sample_due { border-left:2px solid var(--listing-state-sample-due) !important; }
.ajax-contents-table tr.state-sample_due:hover { background-color: var(--listing-state-sample-due-hover); }

/* state sample_received */
.ajax-contents-table tr.state-sample_received { border-left:2px solid var(--listing-state-sample-received) !important; }
.ajax-contents-table td.result.state-sample_received { border-left:2px solid var(--listing-state-sample-received) !important; }
.ajax-contents-table tr.state-sample_received:hover { background-color: var(--listing-state-sample-received-hover); }

/* state retracted */
.ajax-contents-table tr.state-retracted { border-left:2px solid var(--listing-state-retracted) !important; }
.ajax-contents-table tr.state-retracted>td:not([rowspan]) { background-color: var(--listing-state-retracted-bg) !important; color: var(--listing-state-retracted-fg); font-style: italic; }
.ajax-contents-table td.result.state-retracted { border-left:2px solid var(--listing-state-retracted) !important; }
.ajax-contents-table tr.state-retracted:hover { background-color: var(--listing-state-retracted-hover); }

/* state to_be_verified */
.ajax-contents-table tr.state-to_be_verified { border-left:2px solid var(--listing-state-to-be-verified) !important; }
.ajax-contents-table td.result.state-to_be_verified { border-left:2px solid var(--listing-state-to-be-verified) !important; }
.ajax-contents-table tr.state-to_be_verified:hover { background-color: var(--listing-state-to-be-verified-hover); }

/* state verified */
.ajax-contents-table tr.state-verified { border-left:2px solid var(--listing-state-verified) !important; }
.ajax-contents-table td.result.state-verified { border-left:2px solid var(--listing-state-verified) !important; }
.ajax-contents-table tr.state-verified:hover { background-color: var(--listing-state-verified-hover); }

/* state published */
.ajax-contents-table tr.state-published { border-left:2px solid var(--listing-state-published) !important; }
.ajax-contents-table td.result.state-published { border-left:2px solid var(--listing-state-published) !important; }
.ajax-contents-table tr.state-published:hover { background-color: var(--listing-state-published-hover); }

/* state invalid */
.ajax-contents-table tr.state-invalid { border-left:2px solid var(--listing-state-invalid) !important; }
.ajax-contents-table td.result.state-invalid { border-left:2px solid var(--listing-state-invalid) !important; }
.ajax-contents-table tr.state-invalid:hover { background-color: var(--listing-state-invalid-hover); }

/* state rejected */
.ajax-contents-table tr.state-rejected { border-left:2px solid var(--listing-state-rejected) !important; }
.ajax-contents-table td.result.state-rejected { border-left:2px solid var(--listing-state-rejected) !important; }
.ajax-contents-table tr.state-rejected:hover { background-color: var(--listing-state-rejected); }

/* state assigned */
.ajax-contents-table tr.state-assigned { border-left:2px solid var(--listing-border-table); }
.ajax-contents-table td.result.state-assigned { border-left:2px solid transparent; }

/* state unassigned */
.ajax-contents-table tr.state-unassigned { border-left:2px solid var(--listing-border-table); }
.ajax-contents-table td.result.state-unassigned { border-left:2px solid transparent; }

/* state cancelled */
.ajax-contents-table tr.state-cancelled { border-left:2px solid var(--listing-state-cancelled) !important; }
.ajax-contents-table tr.state-cancelled:hover { background-color: var(--listing-state-cancelled-hover); }

/* worksheet states */
.ajax-contents-table tr.state-open { border-left:2px solid var(--listing-border-table)  !important; }
.ajax-contents-table tr.state-empty-worksheet { border-left:2px solid var(--listing-border-table) !important; }

/* transposed worksheet layout*/
.ajax-contents-table td.transposed.result.empty { cursor: not-allowed; }
.ajax-contents-table td.transposed.result:hover { background-color: var(--listing-border-divider)!important; }
.ajax-contents-table td.transposed.result.empty:hover { background-color: var(--listing-border-divider); }

/* active/inactive states*/
.ajax-contents-table tr.state-active { border-left:2px solid transparent; }
.ajax-contents-table tr.state-inactive { border-left:2px solid var(--listing-state-inactive-border); }

.ajax-contents-table th.sortable { cursor: pointer; }
.ajax-contents-table th.sortable:hover { background-color: var(--listing-bg-th-hover); }
.ajax-contents-table th:not(.sortable) { cursor: not-allowed; }

/* split-arrow sort indicators are rendered as buttons by
   TableHeaderCell; the old ::after triangle is no longer needed */

/* category */
.ajax-contents-table tr.categoryrow { background-color: var(--listing-category-bg)!important; cursor: pointer; font-weight: bold; font-size: 115%; color: var(--listing-fg-category); }

/* table load mask */
#table-overlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  width: 100%;
  background: var(--listing-overlay-loader);
  opacity: 0.6;
}

/* progress bar */
.ajax-contents-table tr td div.progress { width: 55px; margin-bottom: 0; height: 17px; }
.ajax-contents-table tr td div.progress div.progress-bar { color: var(--listing-bg-muted); background-color: var(--listing-progress-bg); line-height: 17px; font-size: 9px; font-weight:bold; }
.ajax-contents-table tr.state-invalid td div.progress div.progress-bar,
.ajax-contents-table tr.state-cancelled td div.progress div.progress-bar { background-color: var(--listing-progress-bg-disabled); }

/* collapsible rows */
.ajax-contents-table tr.togglerow { cursor: pointer; }
.ajax-contents-table tr.childrow td:first-child { padding-left: 1em; }
.ajax-contents-table tr.childrow td:first-child:before { content: "➥ "; }

/* before item */
.ajax-contents-table tr span.before-item { display: table-cell; line-height: 0; vertical-align: middle; padding-right: 5px; }

/* after item */
.ajax-contents-table tr span.after-item { display: table-cell; line-height: 0; vertical-align: middle;  padding-left: 5px; }

/* Render table form-controls smaller */
.ajax-contents-table tr td div.form-group { display: inline-table; }

/* Top toolbar */
.ajax-contents-table .top-toolbar { padding-bottom: .5em; }

/* Expandable Rows */
.ajax-contents-table tr.contentrow.child td {
    border-top:none;
}
.ajax-contents-table tr.contentrow.collapsed td:first-child:before,
.ajax-contents-table tr.contentrow.expanded td:first-child:before,
.ajax-contents-table tr.contentrow.child td:first-child:before {
    line-height: normal;
    padding-right: 0.5rem;
    vertical-align: bottom;
    color: var(--listing-fg-toggle);
    cursor: pointer;
    float: left;
    width: 20px; /* aligns the toggle symbols */
}
/* node levels (0.75rem is the default td padding) */
.ajax-contents-table th.select-column { width: 10px; }
.ajax-contents-table td.level-0 { padding-left: 0.75rem; }
.ajax-contents-table td.level-1 { padding-left: 1.75rem; }
.ajax-contents-table td.level-2 { padding-left: 2.75rem; }
.ajax-contents-table td.level-3 { padding-left: 3.75rem; }
.ajax-contents-table td.level-4 { padding-left: 4.75rem; }
.ajax-contents-table td.level-5 { padding-left: 5.75rem; }
.ajax-contents-table td.level-6 { padding-left: 6.75rem; }

.ajax-contents-table tr.contentrow.collapsed td:first-child::before {
    content: "▶";
}
.ajax-contents-table tr.contentrow.expanded td:first-child::before {
    content: "▼";
}
.ajax-contents-table tr.contentrow.child td:first-child::before {
    content: "⋯";
}
.ajax-contents-table tr.contentrow.child.collapsed td:first-child::before {
    content: "▶";
}
.ajax-contents-table tr.contentrow.child.expanded td:first-child::before {
    content: "▼";
}

/* Remark Rows */
.ajax-contents-table tr.remarksrow td {
    padding: 0;
    border: none;
}
.ajax-contents-table tr.remarksrow td div.remarks {
    min-height: 20px;
    padding: 5px;
    margin: 5px;
    background-color: var(--listing-bg-muted);
    border: 1px solid var(--listing-border-divider);
    border-radius: 3px;
}

/* Multi choice */
.ajax-contents-table tr td div.multichoice {
    max-height: 120px;
    width: 200px;
    overflow: auto;
    border: 1px solid var(--listing-bg-th-hover);
    border-radius: 3px;
}
.ajax-contents-table tr td div.multichoice ul {
    padding: 0;
    margin: 0;
}
.ajax-contents-table tr td div.multichoice li {
    padding: 6px;
}
.ajax-contents-table tr td div.multichoice li:hover {
    background-color: var(--listing-bg-row-alt);
}

/* Result multi choice */
.ajax-contents-table tr td.Result div.multichoice {
    border: none;
}
.ajax-contents-table tr td.Result div.multichoice li {
    padding: 4px 6px;
}

/* Multi select */
.ajax-contents-table tr td div.multiselect ul {
    padding: 0;
    margin: 0;
}
.ajax-contents-table tr td div.multiselect li {
    padding: 2px 6px;
}

/* Multi value
Same styling as multi-select, cause we do want multi value elements to be fully
aligned when they are rendered close to multiselect counterpart. Since values
are always stored in same order, this styling allows multi values to "refer" to
selected elements from multiselect
*/
.ajax-contents-table tr td div.multivalue ul {
    padding: 0;
    margin: 0;
}
.ajax-contents-table tr td div.multivalue li {
    padding: 2px 6px;
}

/* Rowspan support */
.ajax-contents-table tr td[rowspan] {
    border: 1px solid var(--listing-border-table);
    background-color: white!important;
}
.ajax-contents-table tr td[rowspan]:hover {
    background-color: white!important;
}

/* borderless table */
.ajax-contents-table table.table-borderless td { border: none!important; }
.ajax-contents-table table.table-borderless tr { border: none!important; }

/* Worksheet's slots table */
.ajax-contents-table table.slot-header-table { margin-bottom: 0px; }

/* Results Unit */
.ajax-contents-table span.unit { padding: 0 0.25em; color: black; }


/* Transposed Cell */
.ajax-contents-table td.transposed span.before-item { width: 60px }
.ajax-contents-table td.transposed span.before-item > * { display: block; float: left; padding-right: 5px; }
.ajax-contents-table td.transposed span.before-item input[type=checkbox] { margin: 0; }
.ajax-contents-table td.transposed input { margin-right: 10px; }
.ajax-contents-table td.transposed .before_field { font-size: 85%; display: table-cell; }
.ajax-contents-table td.transposed .after_field { font-size: 85%; display: table-cell; }
.ajax-contents-table td.transposed span.readonly { padding-right: 0.5em; }

/* Regular Cell */
.ajax-contents-table td a.remarks { display: block; }

/* Drag&Drop behavior */
.ajax-contents-table tr.dragging { opacity: 0; }
.ajax-contents-table td.dnd { cursor: move; }

/* Column Filter Styles */
.ajax-contents-table th .column-filter-toggle {
  padding: 0 0.25rem;
  margin-left: 0.25rem;
  opacity: 0.4;
  border: none;
  background: transparent;
  color: inherit;
  font-size: 0.75em;
  vertical-align: middle;
}
.ajax-contents-table th .column-filter-toggle:hover {
  opacity: 0.8;
}
.ajax-contents-table th .column-filter-toggle.active {
  opacity: 1;
  color: var(--listing-bs-primary);
}
.ajax-contents-table tr.column-filter-row td {
  padding: 0.25rem 0.5rem;
  background-color: var(--listing-bs-bg-light);
  border-bottom: 1px solid var(--listing-bs-border-soft);
}
.ajax-contents-table tr.column-filter-row td.empty {
  background-color: transparent;
  border-bottom: none;
}
.ajax-contents-table tr.column-filter-row .input-group {
  flex-wrap: nowrap;
}
.ajax-contents-table tr.column-filter-row input.form-control,
.ajax-contents-table tr.column-filter-row select.form-control {
  min-width: 80px;
}
.ajax-contents-table tr.column-filter-row input[type="date"].form-control {
  min-width: 130px;
}
.ajax-contents-table tr.column-filter-row input:disabled,
.ajax-contents-table tr.column-filter-row select:disabled {
  background-color: var(--listing-bs-bg-hover);
  cursor: not-allowed;
}
.ajax-contents-table tr.column-filter-row select.form-control {
  padding-right: 1.5rem;
  appearance: auto;
}
.ajax-contents-table tr.column-filter-row .input-group-append .btn {
  border-color: var(--listing-bs-border);
}
/* Ensure searchable-select input has correct border radius in input-group */
.ajax-contents-table tr.column-filter-row .input-group > .searchable-select > .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

/* Searchable Select Styles */
.searchable-select {
  position: relative;
  flex: 1;
}
.searchable-select input.form-control {
  width: 100%;
}
.searchable-select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 250px;
  overflow-y: auto;
  background: white;
  border: 1px solid var(--listing-bs-border);
  border-top: none;
  border-radius: 0 0 0.25rem 0.25rem;
  z-index: 1050;
  box-shadow: var(--listing-shadow-dropdown);
}
.searchable-select-option {
  padding: 0.375rem 0.75rem;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.searchable-select-option:hover,
.searchable-select-option.highlighted {
  background-color: var(--listing-bs-bg-hover);
}
.searchable-select-option.selected {
  background-color: var(--listing-bs-primary);
  color: white;
}
.searchable-select-option.selected.highlighted {
  background-color: var(--listing-bs-primary-dark);
}
.searchable-select-hint {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  color: var(--listing-bs-secondary);
  background: var(--listing-bs-bg-light);
  border: 1px solid var(--listing-bs-border);
  border-top: 1px dashed var(--listing-bs-border-soft);
  text-align: center;
}

/* ================================================================== */
/* Saved Filters + Column Filter Controls                             */
/*                                                                    */
/* Aesthetic: calm-clinical. One accent (SENAITE blue), hairline      */
/* dividers, hover-revealed actions, monospaced preset names.         */
/*                                                                    */
/* The palette lives in --sf-* custom properties so a single edit     */
/* re-skins everything. Token roles:                                  */
/*   bg / fg          surface + text                                  */
/*   border / hairline   default control + soft divider               */
/*   accent           SENAITE blue (active / focus)                   */
/*   success          preset applied                                  */
/*   warning          default-preset gold + dirty amber               */
/*   danger           destructive                                     */
/* Each role exposes a -soft (subtle bg), -border, and -fg variant.   */
/* ================================================================== */



/* ------------------------------------------------------------------ */
/*  1. Saved filters — toggle pill                                    */
/* ------------------------------------------------------------------ */
.saved-filters {
  position: relative;
  display: inline-flex;
  margin-left: 0.5rem;
}
.saved-filters-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  height: calc(1.5em + 0.5rem + 2px);  /* matches Bootstrap btn-sm */
  padding: 0 0.6rem;
  background: var(--sf-bg);
  color: var(--sf-fg-muted);
  border: 1px solid var(--sf-border);
  border-radius: var(--sf-radius-pill);
  font-size: 0.8125rem;
  line-height: 1;
  cursor: pointer;
  transition: background-color var(--sf-trans-fast), border-color var(--sf-trans-fast),
              color var(--sf-trans-fast), box-shadow var(--sf-trans-fast);
}
.saved-filters-toggle:hover,
.saved-filters-toggle.is-open {
  background: var(--sf-bg-hover);
  border-color: var(--sf-fg-faint);
  color: var(--sf-fg);
}
.saved-filters-toggle:focus {
  outline: none;
  box-shadow: 0 0 0 .15rem var(--sf-accent-overlay-20);
}
/* Applied (success) — wins over hover/open */
.saved-filters-toggle.has-applied {
  background: var(--sf-success-soft);
  border-color: var(--sf-success-border);
  color: var(--sf-success);
}
.saved-filters-toggle .saved-filters-count {
  display: inline-block;
  min-width: 1.25rem;
  padding: 0 .3rem;
  background: var(--sf-fg-mutest);
  color: var(--sf-bg);
  font-size: .6875rem;
  font-weight: 600;
  line-height: 1.05rem;
  border-radius: var(--sf-radius-pill);
  text-align: center;
}
.saved-filters-toggle.has-applied .saved-filters-count {
  background: var(--sf-success);
}

/* When the toggle sits inside a Bootstrap input-group prepend slot
   (SearchBox), match the input-group radii and height. */
.searchbox-prepend {
  display: flex;
  align-items: stretch;
}
.searchbox-prepend .saved-filters {
  margin-left: 0;
  display: flex;
  align-items: stretch;
}
.searchbox-prepend .saved-filters-toggle {
  height: 100%;
  padding: 0 0.65rem;
  border-right: 0;
  border-radius: 0.2rem 0 0 0.2rem;
}
.searchbox-prepend .saved-filters-toggle .saved-filters-count {
  margin-left: 0.15rem;
}
.searchbox-prepend .saved-filters-menu {
  left: 0;
  right: auto;
  text-align: left;
}


/* ------------------------------------------------------------------ */
/*  2. Saved filters — dropdown menu                                  */
/* ------------------------------------------------------------------ */
.saved-filters-menu {
  position: absolute;
  top: calc(100% + 0.35rem);
  left: 0;
  z-index: 1050;
  min-width: 280px;
  background: var(--sf-bg);
  border: 1px solid var(--sf-border-card);
  border-radius: var(--sf-radius-card);
  box-shadow: var(--sf-shadow-card);
  animation: savedFiltersIn var(--sf-trans-fast)-out;
}
@keyframes savedFiltersIn {
  from { opacity: 0; transform: translateY(-2px); }
  to   { opacity: 1; transform: translateY(0);    }
}
.saved-filters-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: .65rem .85rem .5rem;
  border-bottom: 1px solid var(--sf-hairline);
}
.saved-filters-title {
  font-size: .75rem;
  font-weight: 600;
  letter-spacing: .04em;
  text-transform: uppercase;
  color: var(--sf-fg-mutest);
}
.saved-filters-hint {
  font-size: .6875rem;
  color: var(--sf-fg-faint);
  font-style: italic;
}
.saved-filter-empty {
  padding: 1.1rem .85rem;
  font-size: .8125rem;
  text-align: center;
  color: var(--sf-fg-empty);
}


/* ------------------------------------------------------------------ */
/*  3. Saved filters — list rows                                      */
/* ------------------------------------------------------------------ */
.saved-filter-list {
  list-style: none;
  margin: 0;
  padding: .25rem 0;
  max-height: 320px;
  overflow-y: auto;
}
.saved-filter-item {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  position: relative;
}
.saved-filter-item + .saved-filter-item {
  border-top: 1px solid var(--sf-divider);
}
.saved-filter-item:hover            { background: var(--sf-bg-row-hover); }
.saved-filter-item.is-default       { background: var(--sf-warning-row); }
.saved-filter-item.is-default:hover { background: var(--sf-warning-row-hover); }
.saved-filter-item.is-applied       { background: var(--sf-success-row); }
.saved-filter-item.is-applied:hover { background: var(--sf-success-row-hover); }
.saved-filter-item.is-applied.is-default { background: var(--sf-warning-row-both); }
/* dirty = applied + user edits diverge from stored payload */
.saved-filter-item.is-applied.is-dirty       { background: var(--sf-dirty-row); }
.saved-filter-item.is-applied.is-dirty:hover { background: var(--sf-dirty-row-hover); }

/* Row body: marker + name + tags (button so the whole row is clickable) */
.saved-filter-apply {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  gap: .5rem;
  min-width: 0;
  padding: .5rem .85rem;
  background: transparent;
  border: 0;
  text-align: left;
  cursor: pointer;
  color: var(--sf-fg);
}
.saved-filter-apply:focus {
  outline: none;
  background: var(--sf-accent-soft);
}
.saved-filter-marker {
  flex: 0 0 auto;
  width: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--sf-border);
  font-size: .75rem;
}
.saved-filter-item.is-applied .saved-filter-marker         { color: var(--sf-success); }
.saved-filter-item.is-applied.is-dirty .saved-filter-marker{ color: var(--sf-warning-star-hover); }

.saved-filter-name {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo,
               Consolas, "Liberation Mono", monospace;
  font-size: .8125rem;
}
/* Micro tags (auto / modified) — same shape, different colour */
.saved-filter-default-tag,
.saved-filter-dirty-tag {
  flex: 0 0 auto;
  font-size: .625rem;
  letter-spacing: .06em;
  text-transform: uppercase;
  padding: .05rem .35rem;
  border-radius: 3px;
}
.saved-filter-default-tag { color: var(--sf-warning-tag-fg); background: var(--sf-warning-tag-bg); }
.saved-filter-dirty-tag   { color: var(--sf-dirty-tag-fg); background: var(--sf-dirty-tag-bg); }


/* ------------------------------------------------------------------ */
/*  4. Saved filters — row actions (rename, star, delete, update,     */
/*     revert). Hover-revealed except on default and dirty rows.      */
/* ------------------------------------------------------------------ */
.saved-filter-actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 2px;
  padding-right: .35rem;
  opacity: 0;
  transition: opacity var(--sf-trans-fast);
}
.saved-filter-item:hover         .saved-filter-actions,
.saved-filter-item:focus-within  .saved-filter-actions,
.saved-filter-item.is-default    .saved-filter-actions,
.saved-filter-item.is-dirty      .saved-filter-actions {
  opacity: 1;
}
.saved-filter-action {
  appearance: none;
  background: transparent;
  border: 0;
  width: 1.4rem;
  height: 1.4rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: var(--sf-fg-faint);
  cursor: pointer;
  transition: color var(--sf-trans-fast), background-color var(--sf-trans-fast);
}
/* Pin every action glyph to the same optical box — FontAwesome's
   per-icon metrics make star/check/×/pen otherwise vary noticeably. */
.saved-filter-action i {
  font-size: .75rem;
  line-height: 1;
  width: .8rem;
  height: .8rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.saved-filter-action:hover {
  background: var(--sf-shadow-overlay);
  color: var(--sf-fg);
}
.saved-filter-action-star.is-on        { color: var(--sf-warning-star); }
.saved-filter-action-star.is-on:hover  { color: var(--sf-warning-star-hover); }
.saved-filter-action-delete:hover {
  color: var(--sf-danger);
  background: var(--sf-danger-overlay-08);
}
.saved-filter-action-update        { color: var(--sf-accent); }
.saved-filter-action-update:hover  { background: var(--sf-accent-overlay-08); color: var(--sf-accent); }
.saved-filter-action-revert:hover  { background: var(--sf-shadow-overlay); color: var(--sf-fg-muted); }


/* ------------------------------------------------------------------ */
/*  5. Saved filters — footer (Save current view button)              */
/* ------------------------------------------------------------------ */
.saved-filters-footer {
  padding: .5rem .65rem .65rem;
  border-top: 1px solid var(--sf-hairline);
}
.saved-filters-save {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: .4rem;
  width: 100%;
  padding: .4rem .65rem;
  background: var(--sf-bg);
  color: var(--sf-accent);
  border: 1px dashed var(--sf-accent-border);
  border-radius: 6px;
  font-size: .8125rem;
  cursor: pointer;
  transition: background-color var(--sf-trans-fast), border-color var(--sf-trans-fast);
}
.saved-filters-save:hover {
  background: var(--sf-accent-soft);
  border-color: var(--sf-accent);
  border-style: solid;
}
.saved-filters-save i { font-size: .7rem; }


/* ------------------------------------------------------------------ */
/*  6. Saved filters — inline editors (save / rename)                 */
/* ------------------------------------------------------------------ */
.saved-filter-edit,
.saved-filters-save-row {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  background: var(--sf-bg-edit-row);
}
.saved-filter-edit       { padding: .35rem .5rem; }
.saved-filters-save-row  { padding: .5rem .65rem; border-top: 1px solid var(--sf-hairline); }

.saved-filter-edit-input {
  flex: 1 1 auto;
  min-width: 0;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: .8125rem;
  padding: .25rem .5rem;
  background: var(--sf-bg);
  border: 1px solid var(--sf-accent-input-border);
  border-radius: 4px;
  color: var(--sf-fg);
  outline: none;
  transition: border-color var(--sf-trans-fast), box-shadow var(--sf-trans-fast);
}
.saved-filter-edit-input:focus {
  border-color: var(--sf-accent-focus);
  box-shadow: 0 0 0 .15rem var(--sf-accent-overlay-15);
}
.saved-filter-edit-confirm,
.saved-filter-edit-cancel {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.7rem;
  height: 1.7rem;
  background: var(--sf-bg);
  border: 1px solid var(--sf-border-soft);
  border-radius: 4px;
  font-size: .75rem;
  color: var(--sf-fg-muted);
  cursor: pointer;
  transition: background-color var(--sf-trans-fast), border-color var(--sf-trans-fast),
              color var(--sf-trans-fast);
}
.saved-filter-edit-confirm        { color: var(--sf-accent); border-color: var(--sf-accent-border); }
.saved-filter-edit-confirm:hover  { background: var(--sf-accent); border-color: var(--sf-accent); color: var(--sf-bg); }
.saved-filter-edit-cancel:hover   { background: var(--sf-bg-hover); border-color: var(--sf-fg-faint); color: var(--sf-fg); }


/* ------------------------------------------------------------------ */
/*  7. Saved filters — inline delete confirm                          */
/* ------------------------------------------------------------------ */
.saved-filter-confirm {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: .5rem;
  padding: .45rem .65rem;
  background: var(--sf-danger-soft);
  border-top: 1px solid var(--sf-danger-hairline);
  border-bottom: 1px solid var(--sf-danger-hairline);
  font-size: .8125rem;
  color: var(--sf-danger-fg);
}
.saved-filter-confirm-text {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.saved-filter-confirm-text strong {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-weight: 600;
  color: var(--sf-danger-fg-strong);
}
.saved-filter-confirm-actions {
  flex: 0 0 auto;
  display: flex;
  gap: 4px;
}
.saved-filter-confirm-cancel,
.saved-filter-confirm-confirm {
  flex: 0 0 auto;
  width: 1.4rem;
  height: 1.4rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 4px;
  border: 1px solid;
  cursor: pointer;
  background: var(--sf-bg);
  transition: background-color var(--sf-trans-fast), border-color var(--sf-trans-fast),
              color var(--sf-trans-fast);
}
.saved-filter-confirm-cancel       { border-color: var(--sf-border-soft); color: var(--sf-fg-muted); }
.saved-filter-confirm-cancel:hover { background: var(--sf-bg-hover); border-color: var(--sf-fg-faint); color: var(--sf-fg); }
.saved-filter-confirm-confirm      { border-color: var(--sf-danger-border); color: var(--sf-danger-fg); }
.saved-filter-confirm-confirm:hover{ background: var(--sf-danger); border-color: var(--sf-danger); color: var(--sf-bg); }
.saved-filter-confirm-cancel i,
.saved-filter-confirm-confirm i { font-size: .75rem; line-height: 1; }


/* ================================================================== */
/* Column header — title (ellipsis) + sort arrows + filter funnel     */
/* ================================================================== */

/* Every header cell shares the same height so cells without controls
   don't collapse to a shorter line and the row bobs up and down. */
.ajax-contents-table thead th {
  vertical-align: middle !important;
  height: 2.5rem;
  line-height: 1.25;
}

/* Inner flex container: title flexes (shrinks with ellipsis), the
   controls cluster stays fully visible on the right edge. */
.ajax-contents-table thead th .column-header-inner {
  display: flex;
  align-items: center;
  gap: .35rem;
  width: 100%;
  min-width: 0;
}
.ajax-contents-table thead th .column-title {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.ajax-contents-table thead th .column-header-controls {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  white-space: nowrap;  /* arrows + funnel never split */
}

/* --- Column-config trigger group: trigger button + small reset --- */
/* The wrapper is right-aligned via Bootstrap's \`.float-right\`; the
   \`inline-flex\` here is only for the children's layout (gap between
   trigger + reset icon). */
.tcc-trigger-group {
  display: inline-flex;
  align-items: center;
  gap: .15rem;
}
.tcc-reset {
  /* Icon-only, muted; promotes to accent on hover so it reads as
     "secondary action" next to the main trigger. */
  padding: .15rem .35rem;
  line-height: 1;
  font-size: .85rem;
  color: var(--sf-muted, #8a94a6);
  text-decoration: none;
}
.tcc-reset:hover, .tcc-reset:focus {
  color: var(--sf-accent, #1976d2);
  text-decoration: none;
}

/* --- Header DnD: grip handle, grab cursor, ghost, drop indicator ---- */
/* Sits at the trailing edge of the controls cluster (right of the
   funnel).  Hidden by default; only the hovered or actively-dragged
   <th> shows it.  visibility (not display) keeps the slot width
   stable so the title doesn't reflow when the cursor enters. */
.ajax-contents-table thead th .column-drag-handle {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  margin-left: .15rem;
  color: var(--sf-muted, #8a94a6);
  font-size: .8em;
  opacity: 0;
  visibility: hidden;
  transition: opacity .12s ease, color .12s ease;
  cursor: grab;
}
.ajax-contents-table thead th .column-drag-handle:active { cursor: grabbing; }
.ajax-contents-table thead th:hover .column-drag-handle,
.ajax-contents-table thead th.is-dragging .column-drag-handle {
  opacity: .9;
  visibility: visible;
  color: var(--sf-accent, #1976d2);
}
.ajax-contents-table thead th.reorderable {
  /* Grab cursor lives on the handle only — see .column-drag-handle
     below — so the funnel and sort buttons keep their normal feel. */
  position: relative;
}
.ajax-contents-table thead th.reorderable.is-dragging { opacity: .4; }

/* Drop indicator: a 2px accent rule along the leading/trailing edge
   of the hovered cell.  Mirrors the above/below indicator in the
   column-config popover, just rotated 90°. */
.ajax-contents-table thead th.is-drop-before::before,
.ajax-contents-table thead th.is-drop-after::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  background: var(--sf-accent, #1976d2);
  pointer-events: none;
  z-index: 2;
}
.ajax-contents-table thead th.is-drop-before::before { left: -1px; }
.ajax-contents-table thead th.is-drop-after::after  { right: -1px; }

/* --- Sort arrows: hidden until hover, revealed on the active col --- */
.column-sort-arrows {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  margin-left: 0;
  vertical-align: middle;
  line-height: 1;
  opacity: 0;
  transition: opacity var(--sf-trans-fast);
}
.ajax-contents-table th.sortable:hover .column-sort-arrows,
.ajax-contents-table th.active         .column-sort-arrows {
  opacity: 1;
}
.column-sort-arrow {
  appearance: none;
  background: transparent;
  border: 0;
  padding: 0;
  width: 14px;
  height: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--sf-fg-faint);
  font-size: .55rem;
  border-radius: 2px;
  transition: color var(--sf-trans-fast), background-color var(--sf-trans-fast);
}
.column-sort-arrow:hover  { color: var(--sf-accent); background: var(--sf-accent-overlay-08); }
.column-sort-arrow.active { color: var(--sf-accent); }
/* Mute the non-active arrow when one is active, so the eye reads the
   current direction at a glance. */
.ajax-contents-table th.active .column-sort-arrow:not(.active) {
  color: var(--sf-border);
}

/* --- Filter funnel: hidden until hover; permanent when filtering --- */
.ajax-contents-table th .column-filter-toggle {
  vertical-align: middle;
  opacity: 0;
  transition: opacity var(--sf-trans-fast);
}
.ajax-contents-table th:hover         .column-filter-toggle,
.ajax-contents-table th:focus-within  .column-filter-toggle,
.ajax-contents-table th .column-filter-toggle.active {
  opacity: 1;
}


/* ================================================================== */
/* Column filter row — refined search strip below the header          */
/* ================================================================== */
.column-filter-row > td {
  background: var(--sf-bg-subtle);
  border-top: 1px solid var(--sf-hairline);
  border-bottom: 1px solid var(--sf-hairline);
  padding: .3rem .4rem;
}
.column-filter-row > td.empty { background: var(--sf-bg-subtle); }

.column-filter-row .input-group-sm > .form-control,
.column-filter-row .searchable-select input {
  background: var(--sf-bg);
  border-color: var(--sf-border-soft);
  border-radius: 4px;
  box-shadow: none;
  transition: border-color var(--sf-trans-fast), box-shadow var(--sf-trans-fast);
}
.column-filter-row .input-group-sm > .form-control:focus,
.column-filter-row .searchable-select input:focus {
  border-color: var(--sf-accent-border);
  box-shadow: 0 0 0 .15rem var(--sf-accent-overlay-15);
}
.column-filter-row .btn-outline-secondary {
  background: var(--sf-bg);
  border-color: var(--sf-border-soft);
  color: var(--sf-fg-mutest);
  transition: color var(--sf-trans-fast), background-color var(--sf-trans-fast),
              border-color var(--sf-trans-fast);
}
.column-filter-row .btn-outline-secondary:hover {
  background: var(--sf-bg-hover);
  border-color: var(--sf-fg-faint);
  color: var(--sf-fg);
}

/* ================================================================== */
/* Table column config panel (TableColumnConfig.js)                   */
/* Calm-clinical: drag handle on the left, eye toggle on the right,   */
/* search + counter + bulk actions on top, hidden columns muted at    */
/* the bottom. Drop indicator is a 2px accent line between rows.      */
/* ================================================================== */

.tcc-panel {
  /* Portal'd to document.body. The component supplies top/left/width
     via inline style based on the trigger's bounding rect. Fixed
     positioning means no parent overflow can clip the panel and the
     stacking context is the document root, so z-index works globally. */
  position: fixed;
  z-index: 1080;
  max-height: 60vh;
  display: flex;
  flex-direction: column;
  background: var(--sf-bg);
  border: 1px solid var(--sf-border-card);
  border-radius: var(--sf-radius-card);
  box-shadow: var(--sf-shadow-card), 0 8px 24px rgba(16,24,40,.08));
  padding: 0;
  font-size: .8125rem;
  overflow: hidden;
  animation: tccPanelIn .12s ease-out;
}
@keyframes tccPanelIn {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0);    }
}

/* --- header --- */
.tcc-header {
  border-bottom: 1px solid var(--sf-hairline);
  padding: .65rem .85rem;
  flex: 0 0 auto;
  background: var(--sf-bg-subtle);
}
.tcc-header-top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: .5rem;
  margin-bottom: .5rem;
}
.tcc-title-block { display: flex; flex-direction: column; min-width: 0; }
.tcc-title {
  font-size: .75rem;
  font-weight: 600;
  letter-spacing: .04em;
  text-transform: uppercase;
  color: var(--sf-fg-mutest);
}
.tcc-description {
  font-size: .6875rem;
  color: var(--sf-fg-faint);
  font-style: italic;
  margin-top: .15rem;
}
.tcc-counter {
  flex: 0 0 auto;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: .75rem;
  font-weight: 600;
  color: var(--sf-fg-muted);
  background: var(--sf-bg);
  border: 1px solid var(--sf-hairline);
  border-radius: 999px;
  padding: .1rem .55rem;
}
.tcc-counter-sep { margin: 0 .15rem; color: var(--sf-fg-faint); }

.tcc-header-tools {
  display: flex;
  align-items: center;
  gap: .5rem;
  flex-wrap: wrap;
}
.tcc-search { flex: 1 1 14rem; min-width: 12rem; }
.tcc-bulk   { display: flex; gap: .35rem; flex: 0 0 auto; }

/* --- body --- */
.tcc-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: .25rem 0 .35rem;
}

.tcc-section { padding: .25rem 0; }
.tcc-section.is-muted { background: var(--sf-bg-subtle); }
.tcc-section.is-muted + .tcc-section { border-top: 1px solid var(--sf-hairline); }
.tcc-section-header {
  display: flex;
  align-items: baseline;
  gap: .5rem;
  padding: .35rem .85rem .25rem;
}
.tcc-section-label {
  font-size: .6875rem;
  font-weight: 600;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: var(--sf-fg-mutest);
}
.tcc-section-count {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: .6875rem;
  color: var(--sf-fg-faint);
}

.tcc-empty {
  padding: .45rem .85rem;
  font-size: .75rem;
  color: var(--sf-fg-empty);
  font-style: italic;
}

/* --- list rows --- */
.tcc-list { list-style: none; margin: 0; padding: 0; }

.tcc-row {
  display: flex;
  align-items: center;
  gap: .5rem;
  padding: .25rem .85rem;
  position: relative;
  transition: background-color var(--sf-trans-fast);
}
.tcc-row + .tcc-row { border-top: 1px solid var(--sf-divider); }
.tcc-row:hover { background: var(--sf-bg-row-hover); }

.tcc-row.is-dragging { opacity: .35; }

/* Drop indicator: a hairline 2px accent line above or below the
   targeted row. Pointer-events:none so it doesn't eat the drop. */
.tcc-row.is-drop-above::before,
.tcc-row.is-drop-below::after {
  content: "";
  position: absolute;
  left: .85rem;
  right: .85rem;
  height: 2px;
  background: var(--sf-accent);
  border-radius: 2px;
  pointer-events: none;
}
.tcc-row.is-drop-above::before { top: -1px; }
.tcc-row.is-drop-below::after  { bottom: -1px; }

/* drag handle — only this is draggable */
.tcc-handle {
  appearance: none;
  background: transparent;
  border: 0;
  padding: 0;
  width: 1.4rem;
  height: 1.4rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: var(--sf-fg-faint);
  cursor: grab;
  flex: 0 0 auto;
}
.tcc-handle:hover { background: var(--sf-shadow-overlay); color: var(--sf-fg-muted); }
.tcc-handle:active { cursor: grabbing; }
.tcc-handle i { font-size: .8125rem; }
.tcc-handle.is-placeholder {
  /* Hidden rows have no handle — reserve the same width for alignment. */
  cursor: default;
  visibility: hidden;
}

/* label */
.tcc-label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--sf-fg);
}
.tcc-section.is-muted .tcc-label { color: var(--sf-fg-muted); }

/* trailing action buttons */
.tcc-hide, .tcc-show {
  appearance: none;
  background: transparent;
  border: 0;
  width: 1.6rem;
  height: 1.6rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  flex: 0 0 auto;
  transition: background-color var(--sf-trans-fast),
              color var(--sf-trans-fast);
}
.tcc-hide        { color: var(--sf-fg-faint); }
.tcc-hide:hover  { color: var(--sf-fg);       background: var(--sf-shadow-overlay); }
.tcc-show        { color: var(--sf-accent);   background: var(--sf-accent-soft); }
.tcc-show:hover  { color: var(--sf-bg);       background: var(--sf-accent); }
.tcc-hide i, .tcc-show i { font-size: .75rem; }

/* --- footer --- */
.tcc-footer {
  border-top: 1px solid var(--sf-hairline);
  padding: .45rem .85rem;
  flex: 0 0 auto;
  background: var(--sf-bg-subtle);
}
.tcc-reset {
  appearance: none;
  background: transparent;
  border: 0;
  padding: .15rem .35rem;
  color: var(--sf-fg-mutest);
  font-size: .75rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: .35rem;
  border-radius: 4px;
  transition: color var(--sf-trans-fast), background-color var(--sf-trans-fast);
}
.tcc-reset:hover { color: var(--sf-fg); background: var(--sf-bg-hover); }
.tcc-reset i { font-size: .7rem; }

/* Column-config trigger — quiet, compact, tertiary affordance.
   Sits flush right above the table; meant to be discoverable but
   not loud. */
.tcc-trigger {
  margin: 0 0 .25rem .5rem;
  padding: .05rem .4rem;
  font-size: .6875rem;
  line-height: 1.2;
  letter-spacing: .02em;
  color: var(--sf-fg-mutest);
  border-color: var(--sf-hairline);
  background: transparent;
}
.tcc-trigger:hover,
.tcc-trigger:focus {
  color: var(--sf-fg-muted);
  border-color: var(--sf-border-soft);
  background: var(--sf-bg-hover);
  box-shadow: none;
}
.tcc-trigger i {
  font-size: .65rem;
  opacity: .7;
}

/* Sample label chips — rendered under Sample ID by senaite.core's
   SamplesView.folderitem. The chip itself is a link that toggles
   the \`\`?labels=<name>\`\` URL filter; the × button posts to
   @@remove_label and refreshes the row. */
.sample-id-with-labels {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: .15rem;
}
.sample-labels {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: .2rem;
  text-align: left;
}
.sample-label {
  display: inline-flex;
  align-items: center;
  padding: 0 .35rem;
  height: 1.15rem;
  font-size: .65rem;
  font-weight: 500;
  line-height: 1;
  color: var(--sf-fg-muted, #495057);
  background: var(--sf-bg-hover, #f1f3f5);
  border: 1px solid var(--sf-hairline, #e5e7eb);
  border-radius: 3px;
  text-decoration: none;
  cursor: default;
  transition: background-color .12s ease, color .12s ease,
              border-color .12s ease;
}
.sample-label.is-filterable {
  cursor: pointer;
}
.sample-label.is-filterable:hover,
.sample-label.is-filterable:focus {
  filter: brightness(0.95);
  text-decoration: none;
}
.sample-label.active {
  box-shadow: 0 0 0 1px var(--sf-accent, #0d6efd) inset;
}
.sample-label-text {
  display: inline-block;
}
.sample-label-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: .25rem;
  margin-right: -.15rem;
  width: .8rem;
  height: .8rem;
  padding: 0;
  font-size: .7rem;
  line-height: 1;
  color: inherit;
  background: transparent;
  border: 0;
  border-radius: 2px;
  cursor: pointer;
  opacity: .6;
}
.sample-label-remove:hover,
.sample-label-remove:focus {
  opacity: 1;
  background: rgba(0, 0, 0, .12);
}


/* Manage Labels modal — chip grid + color picker UX. */
.manage-labels-grid {
  margin-top: .25rem;
}
.manage-labels-toggle {
  cursor: pointer;
  opacity: .55;
  transition: opacity .12s ease, box-shadow .12s ease;
}
.manage-labels-toggle:hover,
.manage-labels-toggle:focus {
  opacity: 1;
}
.manage-labels-toggle.is-selected {
  opacity: 1;
  box-shadow: 0 0 0 2px rgba(13, 110, 253, .35);
}
.manage-labels-toggle.is-removed {
  opacity: .55;
  text-decoration: line-through;
  box-shadow: 0 0 0 2px rgba(220, 53, 69, .35);
}
.manage-labels-color {
  flex: 0 0 2.25rem;
  width: 2.25rem;
  height: 2.25rem;
  padding: 2px;
  border: 1px solid var(--sf-border-soft, #cfd4da);
  border-radius: .25rem;
  background: #fff;
  cursor: pointer;
}
.manage-labels-color::-webkit-color-swatch-wrapper {
  padding: 0;
}
.manage-labels-color::-webkit-color-swatch {
  border: none;
  border-radius: 2px;
}
.manage-labels-color::-moz-color-swatch {
  border: none;
  border-radius: 2px;
}
.manage-labels-presets {
  display: flex;
  flex-wrap: wrap;
  gap: .25rem;
}
.manage-labels-preset {
  width: 1.25rem;
  height: 1.25rem;
  padding: 0;
  border: 1px solid rgba(0, 0, 0, .15);
  border-radius: 50%;
  cursor: pointer;
}
.manage-labels-preset:hover,
.manage-labels-preset:focus {
  outline: 2px solid rgba(13, 110, 253, .35);
}

/* Larger chip variant — wraps the page <h1> on the Label view
   (senaite.core renders the heading itself as the chip via an
   @@title override). Sits between the row-chip body size and the
   default H1 — readable as a heading without dominating the
   content area. */
.sample-label.sample-label--lg {
  height: auto;
  padding: .2rem .65rem;
  font-size: 1.25rem;
  line-height: 1.3;
  border-radius: 5px;
}
.sample-label.sample-label--lg .sample-label-text {
  font-weight: 500;
}

/* Active label filter chips, rendered above-right of the listing,
   immediately before the search box. The × removes the filter from
   the page URL. */
.active-label-filters {
  display: inline-flex;
  flex-wrap: wrap;
  gap: .25rem;
  margin-right: .5rem;
}
.active-label-filter {
  display: inline-flex;
  align-items: center;
  /* Compact pill — deliberately smaller than the form-control-sm
     search box next to it so the chip reads as a status indicator
     riding alongside the input, not as a peer button. align-items:
     center on the parent flex row keeps the chip mid-line with the
     search box. */
  height: 1.6rem;
  padding: 0 .35rem 0 .6rem;
  /* Default to the row-chip neutral palette so a Label with no
     color shows the same grey pill in both places. When the
     listing controller resolves the per-label color it sets an
     inline style that wins over these fallbacks. */
  color: var(--sf-fg-muted, #495057);
  background: var(--sf-bg-hover, #f1f3f5);
  border: 1px solid var(--sf-hairline, #e5e7eb);
  border-radius: 3px;
  font-size: .75rem;
  font-weight: 500;
  line-height: 1;
}
.active-label-filter__name {
  display: inline-block;
}
.active-label-filter__remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: .35rem;
  width: 1rem;
  height: 1rem;
  padding: 0;
  font-size: .85rem;
  line-height: 1;
  color: inherit;
  background: transparent;
  border: 0;
  border-radius: 2px;
  cursor: pointer;
  opacity: .7;
}
.active-label-filter__remove:hover,
.active-label-filter__remove:focus {
  opacity: 1;
  background: rgba(0, 0, 0, .08);
}

/* Active column filters indicator, shown on the right of the column
   config row so the user is aware the listing is narrowed down. */
.listing-table-toolbar {
  margin-bottom: .5rem;
}
.listing-table-toolbar__right {
  display: inline-flex;
  align-items: center;
}
.active-column-filters {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: .25rem;
}
.active-column-filter {
  display: inline-flex;
  align-items: center;
  padding: 0 .35rem 0 .6rem;
  color: var(--sf-fg-muted, #495057);
  background: var(--sf-bg-hover, #f1f3f5);
  border: 1px solid var(--sf-hairline, #e5e7eb);
  border-radius: 3px;
  font-size: .75rem;
  font-weight: 500;
  line-height: 1.6rem;
}
.active-column-filter__remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: .35rem;
  width: 1rem;
  height: 1rem;
  padding: 0;
  font-size: .85rem;
  line-height: 1;
  color: inherit;
  background: transparent;
  border: 0;
  border-radius: 2px;
  cursor: pointer;
  opacity: .7;
}
.active-column-filter__remove:hover,
.active-column-filter__remove:focus {
  opacity: 1;
  background: rgba(0, 0, 0, .08);
}
`, "",{"version":3,"sources":["webpack://./listing.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;;AAEvE;EACE,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B,IAAI,uCAAuC;EACrE,0BAA0B,IAAI,uCAAuC;EACrE,0BAA0B,IAAI,uCAAuC;EACrE,0BAA0B,IAAI,uCAAuC;EACrE,0BAA0B,IAAI,uCAAuC;EACrE,0BAA0B,IAAI,uCAAuC;EACrE,0BAA0B,IAAI,uCAAuC;EACrE,0BAA0B,IAAI,uCAAuC;EACrE,0BAA0B,IAAI,uCAAuC;EACrE,0BAA0B,IAAI,uCAAuC;EACrE,0BAA0B,IAAI,uCAAuC;EACrE,0BAA0B,IAAI,uCAAuC;EACrE,0BAA0B,IAAI,uCAAuC;EACrE,0BAA0B,IAAI,uCAAuC;EACrE,0BAA0B,IAAI,uCAAuC;;EAErE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,iCAAiC;EACjC,+CAA+C;EAC/C,+CAA+C;EAC/C,+CAA+C;;EAE/C,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,+BAA+B;;EAE/B,uDAAuD;EACvD,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC,GAAG,sBAAsB;EAC1D,iCAAiC;EACjC,iCAAiC,GAAG,4BAA4B;EAChE,iCAAiC;EACjC,iCAAiC,GAAG,sBAAsB;EAC1D,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC,GAAG,sBAAsB;EAC1D,iCAAiC;;EAEjC,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,8CAA8C;;EAE9C,wBAAwB;EACxB;;oCAEkC;EAClC,uCAAuC;EACvC,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;;EAE1B,qEAAqE;EACrE,qEAAqE;EACrE,sEAAsE;EACtE,qEAAqE;;EAErE,iBAAiB;EACjB,mCAAmC;EACnC,sCAAsC;EACtC,mCAAmC;EACnC,sCAAsC;EACtC,sCAAsC;EACtC,mCAAmC;EACnC,mCAAmC;EACnC,sCAAsC;EACtC,qDAAqD;EACrD,sDAAsD;;EAEtD,iBAAiB;EACjB,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;;EAEtC,qEAAqE;EACrE,6CAA6C;EAC7C,4DAA4D;;EAE5D,+CAA+C;EAC/C,6DAA6D;;EAE7D,yCAAyC;EACzC,uDAAuD;EACvD,yCAAyC;EACzC,yCAAyC;;EAEzC,8CAA8C;EAC9C,4DAA4D;;EAE5D,wCAAwC;EACxC,sDAAsD;;EAEtD,yCAAyC;EACzC,uDAAuD;;EAEvD,uCAAuC;EACvC,qDAAqD;;EAErD,qCAAqC;EACrC,qCAAqC;;EAErC,sCAAsC;EACtC,mDAAmD;;EAEnD,yCAAyC;;EAEzC;yDACuD;EACvD,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,2DAA2D;AAC7D;;;AAGA,0DAA0D;AAC1D,gCAAgC,iDAAiD,EAAE;AACnF,2CAA2C,mDAAmD,EAAE;;AAEhG,qBAAqB;AACrB,2CAA2C,gEAAgE,EAAE;AAC7G,kDAAkD,gEAAgE,EAAE;AACpH,iDAAiD,uDAAuD,EAAE;;AAE1G,0BAA0B;AAC1B,gDAAgD,qEAAqE,EAAE;AACvH,uDAAuD,qEAAqE,EAAE;AAC9H,sDAAsD,4DAA4D,EAAE;;AAEpH,oBAAoB;AACpB,0CAA0C,+DAA+D,EAAE;AAC3G,4DAA4D,8DAA8D,EAAE,wCAAwC,EAAE,kBAAkB,EAAE;AAC1L,iDAAiD,+DAA+D,EAAE;AAClH,gDAAgD,sDAAsD,EAAE;;AAExG,yBAAyB;AACzB,+CAA+C,oEAAoE,EAAE;AACrH,sDAAsD,oEAAoE,EAAE;AAC5H,qDAAqD,2DAA2D,EAAE;;AAElH,mBAAmB;AACnB,yCAAyC,8DAA8D,EAAE;AACzG,gDAAgD,8DAA8D,EAAE;AAChH,+CAA+C,qDAAqD,EAAE;;AAEtG,oBAAoB;AACpB,0CAA0C,+DAA+D,EAAE;AAC3G,iDAAiD,+DAA+D,EAAE;AAClH,gDAAgD,sDAAsD,EAAE;;AAExG,kBAAkB;AAClB,wCAAwC,6DAA6D,EAAE;AACvG,+CAA+C,6DAA6D,EAAE;AAC9G,8CAA8C,oDAAoD,EAAE;;AAEpG,mBAAmB;AACnB,yCAAyC,8DAA8D,EAAE;AACzG,gDAAgD,8DAA8D,EAAE;AAChH,+CAA+C,+CAA+C,EAAE;;AAEhG,mBAAmB;AACnB,yCAAyC,iDAAiD,EAAE;AAC5F,gDAAgD,iCAAiC,EAAE;;AAEnF,qBAAqB;AACrB,2CAA2C,iDAAiD,EAAE;AAC9F,kDAAkD,iCAAiC,EAAE;;AAErF,oBAAoB;AACpB,0CAA0C,+DAA+D,EAAE;AAC3G,gDAAgD,sDAAsD,EAAE;;AAExG,qBAAqB;AACrB,qCAAqC,6DAA6D,EAAE;AACpG,gDAAgD,4DAA4D,EAAE;;AAE9G,+BAA+B;AAC/B,kDAAkD,mBAAmB,EAAE;AACvE,kDAAkD,yDAAyD,EAAE;AAC7G,wDAAwD,+CAA+C,EAAE;;AAEzG,0BAA0B;AAC1B,uCAAuC,iCAAiC,EAAE;AAC1E,yCAAyC,0DAA0D,EAAE;;AAErG,mCAAmC,eAAe,EAAE;AACpD,yCAAyC,4CAA4C,EAAE;AACvF,yCAAyC,mBAAmB,EAAE;;AAE9D;kEACkE;;AAElE,aAAa;AACb,sCAAsC,sDAAsD,EAAE,eAAe,EAAE,iBAAiB,EAAE,eAAe,EAAE,iCAAiC,EAAE;;AAEtL,oBAAoB;AACpB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,WAAW;EACX,yCAAyC;EACzC,YAAY;AACd;;AAEA,iBAAiB;AACjB,0CAA0C,WAAW,EAAE,gBAAgB,EAAE,YAAY,EAAE;AACvF,2DAA2D,8BAA8B,EAAE,4CAA4C,EAAE,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC9L;2EAC2E,qDAAqD,EAAE;;AAElI,qBAAqB;AACrB,oCAAoC,eAAe,EAAE;AACrD,kDAAkD,iBAAiB,EAAE;AACrE,yDAAyD,aAAa,EAAE;;AAExE,gBAAgB;AAChB,2CAA2C,mBAAmB,EAAE,cAAc,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;;AAE5H,eAAe;AACf,0CAA0C,mBAAmB,EAAE,cAAc,EAAE,sBAAsB,GAAG,iBAAiB,EAAE;;AAE3H,uCAAuC;AACvC,4CAA4C,qBAAqB,EAAE;;AAEnE,gBAAgB;AAChB,oCAAoC,oBAAoB,EAAE;;AAE1D,oBAAoB;AACpB;IACI,eAAe;AACnB;AACA;;;IAGI,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,+BAA+B;IAC/B,eAAe;IACf,WAAW;IACX,WAAW,EAAE,8BAA8B;AAC/C;AACA,oDAAoD;AACpD,wCAAwC,WAAW,EAAE;AACrD,kCAAkC,qBAAqB,EAAE;AACzD,kCAAkC,qBAAqB,EAAE;AACzD,kCAAkC,qBAAqB,EAAE;AACzD,kCAAkC,qBAAqB,EAAE;AACzD,kCAAkC,qBAAqB,EAAE;AACzD,kCAAkC,qBAAqB,EAAE;AACzD,kCAAkC,qBAAqB,EAAE;;AAEzD;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA,gBAAgB;AAChB;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,yCAAyC;IACzC,+CAA+C;IAC/C,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,4CAA4C;IAC5C,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,YAAY;AAChB;AACA;IACI,2CAA2C;AAC/C;;AAEA,wBAAwB;AACxB;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;;AAEA;;;;;CAKC;AACD;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,6CAA6C;IAC7C,iCAAiC;AACrC;AACA;IACI,iCAAiC;AACrC;;AAEA,qBAAqB;AACrB,iDAAiD,sBAAsB,EAAE;AACzE,iDAAiD,sBAAsB,EAAE;;AAEzE,4BAA4B;AAC5B,+CAA+C,kBAAkB,EAAE;;AAEnE,iBAAiB;AACjB,iCAAiC,iBAAiB,EAAE,YAAY,EAAE;;;AAGlE,oBAAoB;AACpB,sDAAsD,YAAY;AAClE,0DAA0D,cAAc,EAAE,WAAW,EAAE,kBAAkB,EAAE;AAC3G,2EAA2E,SAAS,EAAE;AACtF,2CAA2C,kBAAkB,EAAE;AAC/D,mDAAmD,cAAc,EAAE,mBAAmB,EAAE;AACxF,kDAAkD,cAAc,EAAE,mBAAmB,EAAE;AACvF,mDAAmD,oBAAoB,EAAE;;AAEzE,iBAAiB;AACjB,oCAAoC,cAAc,EAAE;;AAEpD,uBAAuB;AACvB,mCAAmC,UAAU,EAAE;AAC/C,8BAA8B,YAAY,EAAE;;AAE5C,yBAAyB;AACzB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,gCAAgC;AAClC;AACA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,sDAAsD;AACxD;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,4CAA4C;EAC5C,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,sCAAsC;AACxC;AACA,4EAA4E;AAC5E;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,4CAA4C;AAC9C;AACA;EACE,2CAA2C;EAC3C,YAAY;AACd;AACA;EACE,gDAAgD;AAClD;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,sCAAsC;EACtC,0CAA0C;EAC1C,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;;;;AAIvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kCAAkC,GAAG,6BAA6B;EAClE,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,kCAAkC;EAClC,oCAAoC;EACpC,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf;yEACuE;AACzE;AACA;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,oDAAoD;AACtD;AACA,6CAA6C;AAC7C;EACE,kCAAkC;EAClC,sCAAsC;EACtC,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;;AAEA;yDACyD;AACzD;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,WAAW;EACX,gBAAgB;AAClB;;;AAGA,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE;EACE,kBAAkB;EAClB,yBAAyB;EACzB,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,uCAAuC;EACvC,oCAAoC;EACpC,iCAAiC;EACjC,kDAAkD;AACpD;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,KAAK;AAClD;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,4BAA4B;EAC5B,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;;AAGA,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,uCAAuC;AACzC;AACA,sCAAsC,kCAAkC,EAAE;AAC1E,sCAAsC,iCAAiC,EAAE;AACzE,sCAAsC,uCAAuC,EAAE;AAC/E,sCAAsC,iCAAiC,EAAE;AACzE,sCAAsC,uCAAuC,EAAE;AAC/E,2CAA2C,sCAAsC,EAAE;AACnF,6DAA6D;AAC7D,+CAA+C,+BAA+B,EAAE;AAChF,+CAA+C,qCAAqC,EAAE;;AAEtF,0EAA0E;AAC1E;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;AACA,6DAA6D,wBAAwB,EAAE;AACvF,6DAA6D,mCAAmC,EAAE;;AAElG;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB;qDACmD;EACnD,mBAAmB;AACrB;AACA,gEAAgE;AAChE;;EAEE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;AACA,4BAA4B,+BAA+B,EAAE,oCAAoC,EAAE;AACnG,4BAA4B,6BAA6B,EAAE,kCAAkC,EAAE;;;AAG/F,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,UAAU;EACV,wCAAwC;AAC1C;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,6EAA6E;AAC/E;AACA;sEACsE;AACtE;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA,yCAAyC,6BAA6B,EAAE;AACxE,yCAAyC,mCAAmC,EAAE;AAC9E;EACE,uBAAuB;EACvB,uCAAuC;AACzC;AACA,qCAAqC,uBAAuB,EAAE;AAC9D,qCAAqC,uCAAuC,EAAE,uBAAuB,EAAE;AACvG,qCAAqC,oCAAoC,EAAE,yBAAyB,EAAE;;;AAGtG,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE;EACE,4BAA4B;EAC5B,wCAAwC;AAC1C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oFAAoF;AACtF;AACA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,wBAAwB,gBAAgB,EAAE;;;AAG1C,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iCAAiC;AACnC;AACA,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,qBAAqB,EAAE,wCAAwC,EAAE;;AAE5F;EACE,cAAc;EACd,YAAY;EACZ,qEAAqE;EACrE,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,+CAA+C;EAC/C,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8EAA8E;AAChF;AACA;EACE,oCAAoC;EACpC,oDAAoD;AACtD;AACA;;EAEE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,wBAAwB;EACxB,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf;wCACsC;AACxC;AACA,oCAAoC,uBAAuB,EAAE,qCAAqC,EAAE;AACpG,oCAAoC,4BAA4B,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;AACvH,oCAAoC,8BAA8B,EAAE,gCAAgC,EAAE,mBAAmB,EAAE;;;AAG3H,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,iCAAiC;EACjC,+CAA+C;EAC/C,kDAAkD;EAClD,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qEAAqE;EACrE,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,cAAc;EACd,aAAa;EACb,QAAQ;AACV;AACA;;EAEE,cAAc;EACd,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB;wCACsC;AACxC;AACA,qCAAqC,mCAAmC,EAAE,yBAAyB,EAAE;AACrG,qCAAqC,8BAA8B,EAAE,gCAAgC,EAAE,mBAAmB,EAAE;AAC5H,qCAAqC,qCAAqC,EAAE,0BAA0B,EAAE;AACxG,qCAAqC,4BAA4B,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;AACxH;kCACkC,iBAAiB,EAAE,cAAc,EAAE;;;AAGrE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;;AAEvE;mEACmE;AACnE;EACE,iCAAiC;EACjC,cAAc;EACd,iBAAiB;AACnB;;AAEA;4DAC4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB,GAAG,gCAAgC;AACxD;;AAEA,sEAAsE;AACtE;;2BAE2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE;mDACiD;EACjD,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA,yEAAyE;AACzE;;;+DAG+D;AAC/D;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,8CAA8C;EAC9C,YAAY;AACd;AACA,2DAA2D,gBAAgB,EAAE;AAC7E;;EAEE,WAAW;EACX,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE;qEACmE;EACnE,kBAAkB;AACpB;AACA,wDAAwD,WAAW,EAAE;;AAErE;;6CAE6C;AAC7C;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,oBAAoB;EACpB,UAAU;AACZ;AACA,uDAAuD,UAAU,EAAE;AACnE,sDAAsD,WAAW,EAAE;;AAEnE,wEAAwE;AACxE;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,UAAU;EACV,wCAAwC;AAC1C;AACA;;EAEE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,6EAA6E;AAC/E;AACA,4BAA4B,uBAAuB,EAAE,uCAAuC,EAAE;AAC9F,4BAA4B,uBAAuB,EAAE;AACrD;mCACmC;AACnC;EACE,uBAAuB;AACzB;;AAEA,wEAAwE;AACxE;EACE,sBAAsB;EACtB,UAAU;EACV,wCAAwC;AAC1C;AACA;;;EAGE,UAAU;AACZ;;;AAGA,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE;EACE,+BAA+B;EAC/B,wCAAwC;EACxC,2CAA2C;EAC3C,oBAAoB;AACtB;AACA,gCAAgC,+BAA+B,EAAE;;AAEjE;;EAEE,wBAAwB;EACxB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,8EAA8E;AAChF;AACA;;EAEE,qCAAqC;EACrC,oDAAoD;AACtD;AACA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,0BAA0B;EAC1B;+CAC6C;AAC/C;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;AACvE,uEAAuE;;AAEvE;EACE;;;wEAGsE;EACtE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,uCAAuC;EACvC,oCAAoC;EACpC,iEAAiE;EACjE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,KAAK;AAClD;;AAEA,mBAAmB;AACnB;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,UAAU;EACV,oBAAoB;AACtB;AACA,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE;AACxE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,qEAAqE;EACrE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,oCAAoC;EACpC,oBAAoB;EACpB,qBAAqB;AACvB;AACA,mBAAmB,gBAAgB,EAAE,yBAAyB,EAAE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;AACA,cAAc,eAAe,EAAE,gBAAgB,EAAE;AACjD,cAAc,aAAa,EAAE,WAAW,EAAE,cAAc,EAAE;;AAE1D,iBAAiB;AACjB;EACE,cAAc;EACd,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,eAAe,iBAAiB,EAAE;AAClC,wBAAwB,+BAA+B,EAAE;AACzD,uCAAuC,wCAAwC,EAAE;AACjF;EACE,aAAa;EACb,qBAAqB;EACrB,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,qEAAqE;EACrE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB,YAAY,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAErD;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,iDAAiD;AACnD;AACA,sBAAsB,uCAAuC,EAAE;AAC/D,iBAAiB,kCAAkC,EAAE;;AAErD,uBAAuB,YAAY,EAAE;;AAErC;kEACkE;AAClE;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;AACtB;AACA,iCAAiC,SAAS,EAAE;AAC5C,iCAAiC,YAAY,EAAE;;AAE/C,yCAAyC;AACzC;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;AACA,oBAAoB,oCAAoC,EAAE,yBAAyB,EAAE;AACrF,qBAAqB,gBAAgB,EAAE;AACvC,gBAAgB,mBAAmB,EAAE;AACrC;EACE,uEAAuE;EACvE,eAAe;EACf,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA,mCAAmC,yBAAyB,EAAE;;AAE9D,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd;wCACsC;AACxC;AACA,mBAAmB,yBAAyB,EAAE;AAC9C,mBAAmB,mBAAmB,QAAQ,oCAAoC,EAAE;AACpF,mBAAmB,uBAAuB,IAAI,iCAAiC,EAAE;AACjF,mBAAmB,mBAAmB,QAAQ,4BAA4B,EAAE;AAC5E,2BAA2B,iBAAiB,EAAE;;AAE9C,mBAAmB;AACnB;EACE,wCAAwC;EACxC,sBAAsB;EACtB,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,6EAA6E;AAC/E;AACA,mBAAmB,mBAAmB,EAAE,8BAA8B,EAAE;AACxE,eAAe,gBAAgB,EAAE;;AAEjC;;cAEc;AACd;EACE,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,gCAAgC;EAChC,uBAAuB;AACzB;AACA;;EAEE,yBAAyB;EACzB,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;0CAG0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,uCAAuC;EACvC,6CAA6C;EAC7C,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf;oCACkC;AACpC;AACA;EACE,eAAe;AACjB;AACA;;EAEE,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;;EAEE,UAAU;EACV,8BAA8B;AAChC;;;AAGA,uDAAuD;AACvD;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,mDAAmD;AACrD;AACA;;EAEE,UAAU;AACZ;AACA;EACE,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,gDAAgD;EAChD,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,0CAA0C;AAC5C;;AAEA;;;;kBAIkB;AAClB;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;;kBAEkB;AAClB;EACE,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB;;;;kBAIgB;EAChB,cAAc;EACd,yBAAyB;EACzB;;;mDAGiD;EACjD,kCAAkC;EAClC,uCAAuC;EACvC,6CAA6C;EAC7C,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;;EAEE,UAAU;EACV,8BAA8B;AAChC;;AAEA;kEACkE;AAClE;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kCAAkC;EAClC,uCAAuC;EACvC,6CAA6C;EAC7C,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;;EAEE,UAAU;EACV,8BAA8B;AAChC","sourcesContent":["/* Listing Styles */\n\n/* ================================================================== */\n/* Palette tokens                                                     */\n/*                                                                    */\n/* All colors used below are declared here so a single edit re-skins  */\n/* the listing. --listing-* covers the original SENAITE workflow      */\n/* state palette; --sf-* covers the Saved Filters + Column Header     */\n/* chrome added later.                                                */\n/* ================================================================== */\n\n:root {\n  /* surfaces + neutrals */\n  --sf-bg:           #fff;\n  --sf-bg-subtle:    #fafbfc;   /* column filter strip                */\n  --sf-bg-hover:     #f1f3f5;   /* neutral hover                      */\n  --sf-bg-row-hover: #f7f9fc;   /* preset row hover                   */\n  --sf-bg-edit-row:  #f4f7fb;   /* inline editor row tint             */\n  --sf-hairline:     #eef0f3;   /* internal dividers                  */\n  --sf-divider:      #f3f4f6;   /* between rows                       */\n  --sf-border:       #ced4da;   /* default control border             */\n  --sf-border-soft:  #d8dde3;   /* softer input border                */\n  --sf-border-card:  #e3e6ea;   /* menu card border                   */\n  --sf-fg:           #212529;   /* body text                          */\n  --sf-fg-muted:     #495057;   /* secondary text                     */\n  --sf-fg-mutest:    #6c757d;   /* tertiary text                      */\n  --sf-fg-faint:     #adb5bd;   /* icon idle                          */\n  --sf-fg-faintest:  #ced4da;   /* inactive sort arrow on active col  */\n  --sf-fg-empty:     #868e96;   /* empty-state copy                   */\n\n  /* accent — SENAITE blue */\n  --sf-accent:        #0b5ed7;\n  --sf-accent-border: #9ec5ff;\n  --sf-accent-soft:   #eaf3ff;\n  --sf-accent-focus:  #6ea8fe;\n  --sf-accent-input-border: #c5d6ee;\n  --sf-accent-overlay-08:  rgba(11, 94, 215, .08);\n  --sf-accent-overlay-15:  rgba(11, 94, 215, .15);\n  --sf-accent-overlay-20:  rgba(0, 123, 255, .20);\n\n  /* success — preset applied */\n  --sf-success:        #198754;\n  --sf-success-border: #a3d9b1;\n  --sf-success-soft:   #e9f7ef;\n  --sf-success-row:    #f0f8f3;\n  --sf-success-row-hover: #e3f1e9;\n\n  /* warning — default-preset gold (star) + dirty amber */\n  --sf-warning-star:        #e0a800;\n  --sf-warning-star-hover:  #c69400;\n  --sf-warning-tag-bg:      #fff4c2;  /* \"auto\" tag        */\n  --sf-warning-tag-fg:      #8a6d00;\n  --sf-warning-row:         #fbfaf3;  /* default-preset row tint */\n  --sf-warning-row-hover:   #f7f3e3;\n  --sf-warning-row-both:    #f6f7e9;  /* applied + default */\n  --sf-dirty-row:           #fff7e9;\n  --sf-dirty-row-hover:     #fdeed2;\n  --sf-dirty-tag-bg:        #ffe9c2;  /* \"modified\" tag    */\n  --sf-dirty-tag-fg:        #8a4a00;\n\n  /* danger — destructive */\n  --sf-danger:        #c92a2a;\n  --sf-danger-border: #e6b4b4;\n  --sf-danger-soft:   #fdf3f3;\n  --sf-danger-hairline: #f3dada;\n  --sf-danger-fg:     #842029;\n  --sf-danger-fg-strong: #4d0a0a;\n  --sf-danger-overlay-08: rgba(201, 42, 42, .08);\n\n  /* shadows + animation */\n  --sf-shadow-card:\n    0 1px 2px  rgba(16, 24, 40, .04),\n    0 8px 24px rgba(16, 24, 40, .08);\n  --sf-shadow-overlay: rgba(0, 0, 0, .05);\n  --sf-radius-card: 8px;\n  --sf-radius-pill: 999px;\n  --sf-trans-fast: .12s ease;\n\n  /* ---------------------------------------------------------------- */\n  /* SENAITE workflow / table palette                                 */\n  /* Original swatches sourced from mdbootstrap.com/css/colors/.       */\n  /* ---------------------------------------------------------------- */\n\n  /* table chrome */\n  --listing-border-table:        #ddd;\n  --listing-border-divider:      #e3e3e3;\n  --listing-border-strong:       #000;\n  --listing-bg-muted:            #f5f5f5;\n  --listing-bg-row-alt:          #f9f9f9;\n  --listing-bg-th-hover:         #ccc;\n  --listing-fg-toggle:           #555;\n  --listing-fg-category:         #3E4551;\n  --listing-category-bg:         rgba(96, 125, 139, .1);\n  --listing-overlay-loader:      rgba(255, 255, 255, .6);\n\n  /* progress bar */\n  --listing-progress-fg:         #f5f5f5;\n  --listing-progress-bg:         #33b5e5;\n  --listing-progress-bg-disabled:#c9c9c9;\n\n  /* workflow states — border + row-hover overlay per state           */\n  --listing-state-sample-due:           #ffff8d;\n  --listing-state-sample-due-hover:     rgba(255, 235, 59, .1);\n\n  --listing-state-sample-received:        #a1887f;\n  --listing-state-sample-received-hover:  rgba(121, 85, 72, .1);\n\n  --listing-state-retracted:        #ff6f00;\n  --listing-state-retracted-hover:  rgba(255, 152, 0, .1);\n  --listing-state-retracted-bg:     #eceff1;\n  --listing-state-retracted-fg:     #78909c;\n\n  --listing-state-to-be-verified:        #18ffff;\n  --listing-state-to-be-verified-hover:  rgba(0, 188, 212, .1);\n\n  --listing-state-verified:        #0091ea;\n  --listing-state-verified-hover:  rgba(3, 169, 244, .2);\n\n  --listing-state-published:        #00c853;\n  --listing-state-published-hover:  rgba(76, 175, 80, .2);\n\n  --listing-state-invalid:        #e65100;\n  --listing-state-invalid-hover:  rgba(244, 67, 54, .2);\n\n  --listing-state-rejected:        #abc;\n  --listing-state-rejected-hover:  #abc;\n\n  --listing-state-cancelled:        #000;\n  --listing-state-cancelled-hover:  rgba(0, 0, 0, .1);\n\n  --listing-state-inactive-border:  #616161;\n\n  /* Bootstrap-matching tokens for the searchable-select dropdown and\n     the column-filter-row strip (pre-existing styles). */\n  --listing-bs-primary:           #007bff;\n  --listing-bs-primary-dark:      #0056b3;\n  --listing-bs-secondary:         #6c757d;\n  --listing-bs-border:            #ced4da;\n  --listing-bs-border-soft:       #dee2e6;\n  --listing-bs-bg-light:          #f8f9fa;\n  --listing-bs-bg-hover:          #e9ecef;\n  --listing-shadow-dropdown:      0 4px 6px rgba(0, 0, 0, .1);\n}\n\n\n/* Colors taken from https://mdbootstrap.com/css/colors/ */\n.ajax-contents-table tbody tr { border-left:2px solid var(--listing-border-table); }\n.ajax-contents-table tbody tr:last-child { border-bottom:1px solid var(--listing-border-table); }\n\n/* state sample_due */\n.ajax-contents-table tr.state-sample_due { border-left:2px solid var(--listing-state-sample-due) !important; }\n.ajax-contents-table td.result.state-sample_due { border-left:2px solid var(--listing-state-sample-due) !important; }\n.ajax-contents-table tr.state-sample_due:hover { background-color: var(--listing-state-sample-due-hover); }\n\n/* state sample_received */\n.ajax-contents-table tr.state-sample_received { border-left:2px solid var(--listing-state-sample-received) !important; }\n.ajax-contents-table td.result.state-sample_received { border-left:2px solid var(--listing-state-sample-received) !important; }\n.ajax-contents-table tr.state-sample_received:hover { background-color: var(--listing-state-sample-received-hover); }\n\n/* state retracted */\n.ajax-contents-table tr.state-retracted { border-left:2px solid var(--listing-state-retracted) !important; }\n.ajax-contents-table tr.state-retracted>td:not([rowspan]) { background-color: var(--listing-state-retracted-bg) !important; color: var(--listing-state-retracted-fg); font-style: italic; }\n.ajax-contents-table td.result.state-retracted { border-left:2px solid var(--listing-state-retracted) !important; }\n.ajax-contents-table tr.state-retracted:hover { background-color: var(--listing-state-retracted-hover); }\n\n/* state to_be_verified */\n.ajax-contents-table tr.state-to_be_verified { border-left:2px solid var(--listing-state-to-be-verified) !important; }\n.ajax-contents-table td.result.state-to_be_verified { border-left:2px solid var(--listing-state-to-be-verified) !important; }\n.ajax-contents-table tr.state-to_be_verified:hover { background-color: var(--listing-state-to-be-verified-hover); }\n\n/* state verified */\n.ajax-contents-table tr.state-verified { border-left:2px solid var(--listing-state-verified) !important; }\n.ajax-contents-table td.result.state-verified { border-left:2px solid var(--listing-state-verified) !important; }\n.ajax-contents-table tr.state-verified:hover { background-color: var(--listing-state-verified-hover); }\n\n/* state published */\n.ajax-contents-table tr.state-published { border-left:2px solid var(--listing-state-published) !important; }\n.ajax-contents-table td.result.state-published { border-left:2px solid var(--listing-state-published) !important; }\n.ajax-contents-table tr.state-published:hover { background-color: var(--listing-state-published-hover); }\n\n/* state invalid */\n.ajax-contents-table tr.state-invalid { border-left:2px solid var(--listing-state-invalid) !important; }\n.ajax-contents-table td.result.state-invalid { border-left:2px solid var(--listing-state-invalid) !important; }\n.ajax-contents-table tr.state-invalid:hover { background-color: var(--listing-state-invalid-hover); }\n\n/* state rejected */\n.ajax-contents-table tr.state-rejected { border-left:2px solid var(--listing-state-rejected) !important; }\n.ajax-contents-table td.result.state-rejected { border-left:2px solid var(--listing-state-rejected) !important; }\n.ajax-contents-table tr.state-rejected:hover { background-color: var(--listing-state-rejected); }\n\n/* state assigned */\n.ajax-contents-table tr.state-assigned { border-left:2px solid var(--listing-border-table); }\n.ajax-contents-table td.result.state-assigned { border-left:2px solid transparent; }\n\n/* state unassigned */\n.ajax-contents-table tr.state-unassigned { border-left:2px solid var(--listing-border-table); }\n.ajax-contents-table td.result.state-unassigned { border-left:2px solid transparent; }\n\n/* state cancelled */\n.ajax-contents-table tr.state-cancelled { border-left:2px solid var(--listing-state-cancelled) !important; }\n.ajax-contents-table tr.state-cancelled:hover { background-color: var(--listing-state-cancelled-hover); }\n\n/* worksheet states */\n.ajax-contents-table tr.state-open { border-left:2px solid var(--listing-border-table)  !important; }\n.ajax-contents-table tr.state-empty-worksheet { border-left:2px solid var(--listing-border-table) !important; }\n\n/* transposed worksheet layout*/\n.ajax-contents-table td.transposed.result.empty { cursor: not-allowed; }\n.ajax-contents-table td.transposed.result:hover { background-color: var(--listing-border-divider)!important; }\n.ajax-contents-table td.transposed.result.empty:hover { background-color: var(--listing-border-divider); }\n\n/* active/inactive states*/\n.ajax-contents-table tr.state-active { border-left:2px solid transparent; }\n.ajax-contents-table tr.state-inactive { border-left:2px solid var(--listing-state-inactive-border); }\n\n.ajax-contents-table th.sortable { cursor: pointer; }\n.ajax-contents-table th.sortable:hover { background-color: var(--listing-bg-th-hover); }\n.ajax-contents-table th:not(.sortable) { cursor: not-allowed; }\n\n/* split-arrow sort indicators are rendered as buttons by\n   TableHeaderCell; the old ::after triangle is no longer needed */\n\n/* category */\n.ajax-contents-table tr.categoryrow { background-color: var(--listing-category-bg)!important; cursor: pointer; font-weight: bold; font-size: 115%; color: var(--listing-fg-category); }\n\n/* table load mask */\n#table-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  height: 100%;\n  width: 100%;\n  background: var(--listing-overlay-loader);\n  opacity: 0.6;\n}\n\n/* progress bar */\n.ajax-contents-table tr td div.progress { width: 55px; margin-bottom: 0; height: 17px; }\n.ajax-contents-table tr td div.progress div.progress-bar { color: var(--listing-bg-muted); background-color: var(--listing-progress-bg); line-height: 17px; font-size: 9px; font-weight:bold; }\n.ajax-contents-table tr.state-invalid td div.progress div.progress-bar,\n.ajax-contents-table tr.state-cancelled td div.progress div.progress-bar { background-color: var(--listing-progress-bg-disabled); }\n\n/* collapsible rows */\n.ajax-contents-table tr.togglerow { cursor: pointer; }\n.ajax-contents-table tr.childrow td:first-child { padding-left: 1em; }\n.ajax-contents-table tr.childrow td:first-child:before { content: \"➥ \"; }\n\n/* before item */\n.ajax-contents-table tr span.before-item { display: table-cell; line-height: 0; vertical-align: middle; padding-right: 5px; }\n\n/* after item */\n.ajax-contents-table tr span.after-item { display: table-cell; line-height: 0; vertical-align: middle;  padding-left: 5px; }\n\n/* Render table form-controls smaller */\n.ajax-contents-table tr td div.form-group { display: inline-table; }\n\n/* Top toolbar */\n.ajax-contents-table .top-toolbar { padding-bottom: .5em; }\n\n/* Expandable Rows */\n.ajax-contents-table tr.contentrow.child td {\n    border-top:none;\n}\n.ajax-contents-table tr.contentrow.collapsed td:first-child:before,\n.ajax-contents-table tr.contentrow.expanded td:first-child:before,\n.ajax-contents-table tr.contentrow.child td:first-child:before {\n    line-height: normal;\n    padding-right: 0.5rem;\n    vertical-align: bottom;\n    color: var(--listing-fg-toggle);\n    cursor: pointer;\n    float: left;\n    width: 20px; /* aligns the toggle symbols */\n}\n/* node levels (0.75rem is the default td padding) */\n.ajax-contents-table th.select-column { width: 10px; }\n.ajax-contents-table td.level-0 { padding-left: 0.75rem; }\n.ajax-contents-table td.level-1 { padding-left: 1.75rem; }\n.ajax-contents-table td.level-2 { padding-left: 2.75rem; }\n.ajax-contents-table td.level-3 { padding-left: 3.75rem; }\n.ajax-contents-table td.level-4 { padding-left: 4.75rem; }\n.ajax-contents-table td.level-5 { padding-left: 5.75rem; }\n.ajax-contents-table td.level-6 { padding-left: 6.75rem; }\n\n.ajax-contents-table tr.contentrow.collapsed td:first-child::before {\n    content: \"▶\";\n}\n.ajax-contents-table tr.contentrow.expanded td:first-child::before {\n    content: \"▼\";\n}\n.ajax-contents-table tr.contentrow.child td:first-child::before {\n    content: \"⋯\";\n}\n.ajax-contents-table tr.contentrow.child.collapsed td:first-child::before {\n    content: \"▶\";\n}\n.ajax-contents-table tr.contentrow.child.expanded td:first-child::before {\n    content: \"▼\";\n}\n\n/* Remark Rows */\n.ajax-contents-table tr.remarksrow td {\n    padding: 0;\n    border: none;\n}\n.ajax-contents-table tr.remarksrow td div.remarks {\n    min-height: 20px;\n    padding: 5px;\n    margin: 5px;\n    background-color: var(--listing-bg-muted);\n    border: 1px solid var(--listing-border-divider);\n    border-radius: 3px;\n}\n\n/* Multi choice */\n.ajax-contents-table tr td div.multichoice {\n    max-height: 120px;\n    width: 200px;\n    overflow: auto;\n    border: 1px solid var(--listing-bg-th-hover);\n    border-radius: 3px;\n}\n.ajax-contents-table tr td div.multichoice ul {\n    padding: 0;\n    margin: 0;\n}\n.ajax-contents-table tr td div.multichoice li {\n    padding: 6px;\n}\n.ajax-contents-table tr td div.multichoice li:hover {\n    background-color: var(--listing-bg-row-alt);\n}\n\n/* Result multi choice */\n.ajax-contents-table tr td.Result div.multichoice {\n    border: none;\n}\n.ajax-contents-table tr td.Result div.multichoice li {\n    padding: 4px 6px;\n}\n\n/* Multi select */\n.ajax-contents-table tr td div.multiselect ul {\n    padding: 0;\n    margin: 0;\n}\n.ajax-contents-table tr td div.multiselect li {\n    padding: 2px 6px;\n}\n\n/* Multi value\nSame styling as multi-select, cause we do want multi value elements to be fully\naligned when they are rendered close to multiselect counterpart. Since values\nare always stored in same order, this styling allows multi values to \"refer\" to\nselected elements from multiselect\n*/\n.ajax-contents-table tr td div.multivalue ul {\n    padding: 0;\n    margin: 0;\n}\n.ajax-contents-table tr td div.multivalue li {\n    padding: 2px 6px;\n}\n\n/* Rowspan support */\n.ajax-contents-table tr td[rowspan] {\n    border: 1px solid var(--listing-border-table);\n    background-color: white!important;\n}\n.ajax-contents-table tr td[rowspan]:hover {\n    background-color: white!important;\n}\n\n/* borderless table */\n.ajax-contents-table table.table-borderless td { border: none!important; }\n.ajax-contents-table table.table-borderless tr { border: none!important; }\n\n/* Worksheet's slots table */\n.ajax-contents-table table.slot-header-table { margin-bottom: 0px; }\n\n/* Results Unit */\n.ajax-contents-table span.unit { padding: 0 0.25em; color: black; }\n\n\n/* Transposed Cell */\n.ajax-contents-table td.transposed span.before-item { width: 60px }\n.ajax-contents-table td.transposed span.before-item > * { display: block; float: left; padding-right: 5px; }\n.ajax-contents-table td.transposed span.before-item input[type=checkbox] { margin: 0; }\n.ajax-contents-table td.transposed input { margin-right: 10px; }\n.ajax-contents-table td.transposed .before_field { font-size: 85%; display: table-cell; }\n.ajax-contents-table td.transposed .after_field { font-size: 85%; display: table-cell; }\n.ajax-contents-table td.transposed span.readonly { padding-right: 0.5em; }\n\n/* Regular Cell */\n.ajax-contents-table td a.remarks { display: block; }\n\n/* Drag&Drop behavior */\n.ajax-contents-table tr.dragging { opacity: 0; }\n.ajax-contents-table td.dnd { cursor: move; }\n\n/* Column Filter Styles */\n.ajax-contents-table th .column-filter-toggle {\n  padding: 0 0.25rem;\n  margin-left: 0.25rem;\n  opacity: 0.4;\n  border: none;\n  background: transparent;\n  color: inherit;\n  font-size: 0.75em;\n  vertical-align: middle;\n}\n.ajax-contents-table th .column-filter-toggle:hover {\n  opacity: 0.8;\n}\n.ajax-contents-table th .column-filter-toggle.active {\n  opacity: 1;\n  color: var(--listing-bs-primary);\n}\n.ajax-contents-table tr.column-filter-row td {\n  padding: 0.25rem 0.5rem;\n  background-color: var(--listing-bs-bg-light);\n  border-bottom: 1px solid var(--listing-bs-border-soft);\n}\n.ajax-contents-table tr.column-filter-row td.empty {\n  background-color: transparent;\n  border-bottom: none;\n}\n.ajax-contents-table tr.column-filter-row .input-group {\n  flex-wrap: nowrap;\n}\n.ajax-contents-table tr.column-filter-row input.form-control,\n.ajax-contents-table tr.column-filter-row select.form-control {\n  min-width: 80px;\n}\n.ajax-contents-table tr.column-filter-row input[type=\"date\"].form-control {\n  min-width: 130px;\n}\n.ajax-contents-table tr.column-filter-row input:disabled,\n.ajax-contents-table tr.column-filter-row select:disabled {\n  background-color: var(--listing-bs-bg-hover);\n  cursor: not-allowed;\n}\n.ajax-contents-table tr.column-filter-row select.form-control {\n  padding-right: 1.5rem;\n  appearance: auto;\n}\n.ajax-contents-table tr.column-filter-row .input-group-append .btn {\n  border-color: var(--listing-bs-border);\n}\n/* Ensure searchable-select input has correct border radius in input-group */\n.ajax-contents-table tr.column-filter-row .input-group > .searchable-select > .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n/* Searchable Select Styles */\n.searchable-select {\n  position: relative;\n  flex: 1;\n}\n.searchable-select input.form-control {\n  width: 100%;\n}\n.searchable-select-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  max-height: 250px;\n  overflow-y: auto;\n  background: white;\n  border: 1px solid var(--listing-bs-border);\n  border-top: none;\n  border-radius: 0 0 0.25rem 0.25rem;\n  z-index: 1050;\n  box-shadow: var(--listing-shadow-dropdown);\n}\n.searchable-select-option {\n  padding: 0.375rem 0.75rem;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.searchable-select-option:hover,\n.searchable-select-option.highlighted {\n  background-color: var(--listing-bs-bg-hover);\n}\n.searchable-select-option.selected {\n  background-color: var(--listing-bs-primary);\n  color: white;\n}\n.searchable-select-option.selected.highlighted {\n  background-color: var(--listing-bs-primary-dark);\n}\n.searchable-select-hint {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  color: var(--listing-bs-secondary);\n  background: var(--listing-bs-bg-light);\n  border: 1px solid var(--listing-bs-border);\n  border-top: 1px dashed var(--listing-bs-border-soft);\n  text-align: center;\n}\n\n/* ================================================================== */\n/* Saved Filters + Column Filter Controls                             */\n/*                                                                    */\n/* Aesthetic: calm-clinical. One accent (SENAITE blue), hairline      */\n/* dividers, hover-revealed actions, monospaced preset names.         */\n/*                                                                    */\n/* The palette lives in --sf-* custom properties so a single edit     */\n/* re-skins everything. Token roles:                                  */\n/*   bg / fg          surface + text                                  */\n/*   border / hairline   default control + soft divider               */\n/*   accent           SENAITE blue (active / focus)                   */\n/*   success          preset applied                                  */\n/*   warning          default-preset gold + dirty amber               */\n/*   danger           destructive                                     */\n/* Each role exposes a -soft (subtle bg), -border, and -fg variant.   */\n/* ================================================================== */\n\n\n\n/* ------------------------------------------------------------------ */\n/*  1. Saved filters — toggle pill                                    */\n/* ------------------------------------------------------------------ */\n.saved-filters {\n  position: relative;\n  display: inline-flex;\n  margin-left: 0.5rem;\n}\n.saved-filters-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  height: calc(1.5em + 0.5rem + 2px);  /* matches Bootstrap btn-sm */\n  padding: 0 0.6rem;\n  background: var(--sf-bg);\n  color: var(--sf-fg-muted);\n  border: 1px solid var(--sf-border);\n  border-radius: var(--sf-radius-pill);\n  font-size: 0.8125rem;\n  line-height: 1;\n  cursor: pointer;\n  transition: background-color var(--sf-trans-fast), border-color var(--sf-trans-fast),\n              color var(--sf-trans-fast), box-shadow var(--sf-trans-fast);\n}\n.saved-filters-toggle:hover,\n.saved-filters-toggle.is-open {\n  background: var(--sf-bg-hover);\n  border-color: var(--sf-fg-faint);\n  color: var(--sf-fg);\n}\n.saved-filters-toggle:focus {\n  outline: none;\n  box-shadow: 0 0 0 .15rem var(--sf-accent-overlay-20);\n}\n/* Applied (success) — wins over hover/open */\n.saved-filters-toggle.has-applied {\n  background: var(--sf-success-soft);\n  border-color: var(--sf-success-border);\n  color: var(--sf-success);\n}\n.saved-filters-toggle .saved-filters-count {\n  display: inline-block;\n  min-width: 1.25rem;\n  padding: 0 .3rem;\n  background: var(--sf-fg-mutest);\n  color: var(--sf-bg);\n  font-size: .6875rem;\n  font-weight: 600;\n  line-height: 1.05rem;\n  border-radius: var(--sf-radius-pill);\n  text-align: center;\n}\n.saved-filters-toggle.has-applied .saved-filters-count {\n  background: var(--sf-success);\n}\n\n/* When the toggle sits inside a Bootstrap input-group prepend slot\n   (SearchBox), match the input-group radii and height. */\n.searchbox-prepend {\n  display: flex;\n  align-items: stretch;\n}\n.searchbox-prepend .saved-filters {\n  margin-left: 0;\n  display: flex;\n  align-items: stretch;\n}\n.searchbox-prepend .saved-filters-toggle {\n  height: 100%;\n  padding: 0 0.65rem;\n  border-right: 0;\n  border-radius: 0.2rem 0 0 0.2rem;\n}\n.searchbox-prepend .saved-filters-toggle .saved-filters-count {\n  margin-left: 0.15rem;\n}\n.searchbox-prepend .saved-filters-menu {\n  left: 0;\n  right: auto;\n  text-align: left;\n}\n\n\n/* ------------------------------------------------------------------ */\n/*  2. Saved filters — dropdown menu                                  */\n/* ------------------------------------------------------------------ */\n.saved-filters-menu {\n  position: absolute;\n  top: calc(100% + 0.35rem);\n  left: 0;\n  z-index: 1050;\n  min-width: 280px;\n  background: var(--sf-bg);\n  border: 1px solid var(--sf-border-card);\n  border-radius: var(--sf-radius-card);\n  box-shadow: var(--sf-shadow-card);\n  animation: savedFiltersIn var(--sf-trans-fast)-out;\n}\n@keyframes savedFiltersIn {\n  from { opacity: 0; transform: translateY(-2px); }\n  to   { opacity: 1; transform: translateY(0);    }\n}\n.saved-filters-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  padding: .65rem .85rem .5rem;\n  border-bottom: 1px solid var(--sf-hairline);\n}\n.saved-filters-title {\n  font-size: .75rem;\n  font-weight: 600;\n  letter-spacing: .04em;\n  text-transform: uppercase;\n  color: var(--sf-fg-mutest);\n}\n.saved-filters-hint {\n  font-size: .6875rem;\n  color: var(--sf-fg-faint);\n  font-style: italic;\n}\n.saved-filter-empty {\n  padding: 1.1rem .85rem;\n  font-size: .8125rem;\n  text-align: center;\n  color: var(--sf-fg-empty);\n}\n\n\n/* ------------------------------------------------------------------ */\n/*  3. Saved filters — list rows                                      */\n/* ------------------------------------------------------------------ */\n.saved-filter-list {\n  list-style: none;\n  margin: 0;\n  padding: .25rem 0;\n  max-height: 320px;\n  overflow-y: auto;\n}\n.saved-filter-item {\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n  position: relative;\n}\n.saved-filter-item + .saved-filter-item {\n  border-top: 1px solid var(--sf-divider);\n}\n.saved-filter-item:hover            { background: var(--sf-bg-row-hover); }\n.saved-filter-item.is-default       { background: var(--sf-warning-row); }\n.saved-filter-item.is-default:hover { background: var(--sf-warning-row-hover); }\n.saved-filter-item.is-applied       { background: var(--sf-success-row); }\n.saved-filter-item.is-applied:hover { background: var(--sf-success-row-hover); }\n.saved-filter-item.is-applied.is-default { background: var(--sf-warning-row-both); }\n/* dirty = applied + user edits diverge from stored payload */\n.saved-filter-item.is-applied.is-dirty       { background: var(--sf-dirty-row); }\n.saved-filter-item.is-applied.is-dirty:hover { background: var(--sf-dirty-row-hover); }\n\n/* Row body: marker + name + tags (button so the whole row is clickable) */\n.saved-filter-apply {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  gap: .5rem;\n  min-width: 0;\n  padding: .5rem .85rem;\n  background: transparent;\n  border: 0;\n  text-align: left;\n  cursor: pointer;\n  color: var(--sf-fg);\n}\n.saved-filter-apply:focus {\n  outline: none;\n  background: var(--sf-accent-soft);\n}\n.saved-filter-marker {\n  flex: 0 0 auto;\n  width: 1rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--sf-border);\n  font-size: .75rem;\n}\n.saved-filter-item.is-applied .saved-filter-marker         { color: var(--sf-success); }\n.saved-filter-item.is-applied.is-dirty .saved-filter-marker{ color: var(--sf-warning-star-hover); }\n\n.saved-filter-name {\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Menlo,\n               Consolas, \"Liberation Mono\", monospace;\n  font-size: .8125rem;\n}\n/* Micro tags (auto / modified) — same shape, different colour */\n.saved-filter-default-tag,\n.saved-filter-dirty-tag {\n  flex: 0 0 auto;\n  font-size: .625rem;\n  letter-spacing: .06em;\n  text-transform: uppercase;\n  padding: .05rem .35rem;\n  border-radius: 3px;\n}\n.saved-filter-default-tag { color: var(--sf-warning-tag-fg); background: var(--sf-warning-tag-bg); }\n.saved-filter-dirty-tag   { color: var(--sf-dirty-tag-fg); background: var(--sf-dirty-tag-bg); }\n\n\n/* ------------------------------------------------------------------ */\n/*  4. Saved filters — row actions (rename, star, delete, update,     */\n/*     revert). Hover-revealed except on default and dirty rows.      */\n/* ------------------------------------------------------------------ */\n.saved-filter-actions {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding-right: .35rem;\n  opacity: 0;\n  transition: opacity var(--sf-trans-fast);\n}\n.saved-filter-item:hover         .saved-filter-actions,\n.saved-filter-item:focus-within  .saved-filter-actions,\n.saved-filter-item.is-default    .saved-filter-actions,\n.saved-filter-item.is-dirty      .saved-filter-actions {\n  opacity: 1;\n}\n.saved-filter-action {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  width: 1.4rem;\n  height: 1.4rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  color: var(--sf-fg-faint);\n  cursor: pointer;\n  transition: color var(--sf-trans-fast), background-color var(--sf-trans-fast);\n}\n/* Pin every action glyph to the same optical box — FontAwesome's\n   per-icon metrics make star/check/×/pen otherwise vary noticeably. */\n.saved-filter-action i {\n  font-size: .75rem;\n  line-height: 1;\n  width: .8rem;\n  height: .8rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.saved-filter-action:hover {\n  background: var(--sf-shadow-overlay);\n  color: var(--sf-fg);\n}\n.saved-filter-action-star.is-on        { color: var(--sf-warning-star); }\n.saved-filter-action-star.is-on:hover  { color: var(--sf-warning-star-hover); }\n.saved-filter-action-delete:hover {\n  color: var(--sf-danger);\n  background: var(--sf-danger-overlay-08);\n}\n.saved-filter-action-update        { color: var(--sf-accent); }\n.saved-filter-action-update:hover  { background: var(--sf-accent-overlay-08); color: var(--sf-accent); }\n.saved-filter-action-revert:hover  { background: var(--sf-shadow-overlay); color: var(--sf-fg-muted); }\n\n\n/* ------------------------------------------------------------------ */\n/*  5. Saved filters — footer (Save current view button)              */\n/* ------------------------------------------------------------------ */\n.saved-filters-footer {\n  padding: .5rem .65rem .65rem;\n  border-top: 1px solid var(--sf-hairline);\n}\n.saved-filters-save {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: .4rem;\n  width: 100%;\n  padding: .4rem .65rem;\n  background: var(--sf-bg);\n  color: var(--sf-accent);\n  border: 1px dashed var(--sf-accent-border);\n  border-radius: 6px;\n  font-size: .8125rem;\n  cursor: pointer;\n  transition: background-color var(--sf-trans-fast), border-color var(--sf-trans-fast);\n}\n.saved-filters-save:hover {\n  background: var(--sf-accent-soft);\n  border-color: var(--sf-accent);\n  border-style: solid;\n}\n.saved-filters-save i { font-size: .7rem; }\n\n\n/* ------------------------------------------------------------------ */\n/*  6. Saved filters — inline editors (save / rename)                 */\n/* ------------------------------------------------------------------ */\n.saved-filter-edit,\n.saved-filters-save-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n  background: var(--sf-bg-edit-row);\n}\n.saved-filter-edit       { padding: .35rem .5rem; }\n.saved-filters-save-row  { padding: .5rem .65rem; border-top: 1px solid var(--sf-hairline); }\n\n.saved-filter-edit-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: .8125rem;\n  padding: .25rem .5rem;\n  background: var(--sf-bg);\n  border: 1px solid var(--sf-accent-input-border);\n  border-radius: 4px;\n  color: var(--sf-fg);\n  outline: none;\n  transition: border-color var(--sf-trans-fast), box-shadow var(--sf-trans-fast);\n}\n.saved-filter-edit-input:focus {\n  border-color: var(--sf-accent-focus);\n  box-shadow: 0 0 0 .15rem var(--sf-accent-overlay-15);\n}\n.saved-filter-edit-confirm,\n.saved-filter-edit-cancel {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.7rem;\n  height: 1.7rem;\n  background: var(--sf-bg);\n  border: 1px solid var(--sf-border-soft);\n  border-radius: 4px;\n  font-size: .75rem;\n  color: var(--sf-fg-muted);\n  cursor: pointer;\n  transition: background-color var(--sf-trans-fast), border-color var(--sf-trans-fast),\n              color var(--sf-trans-fast);\n}\n.saved-filter-edit-confirm        { color: var(--sf-accent); border-color: var(--sf-accent-border); }\n.saved-filter-edit-confirm:hover  { background: var(--sf-accent); border-color: var(--sf-accent); color: var(--sf-bg); }\n.saved-filter-edit-cancel:hover   { background: var(--sf-bg-hover); border-color: var(--sf-fg-faint); color: var(--sf-fg); }\n\n\n/* ------------------------------------------------------------------ */\n/*  7. Saved filters — inline delete confirm                          */\n/* ------------------------------------------------------------------ */\n.saved-filter-confirm {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: .5rem;\n  padding: .45rem .65rem;\n  background: var(--sf-danger-soft);\n  border-top: 1px solid var(--sf-danger-hairline);\n  border-bottom: 1px solid var(--sf-danger-hairline);\n  font-size: .8125rem;\n  color: var(--sf-danger-fg);\n}\n.saved-filter-confirm-text {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.saved-filter-confirm-text strong {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-weight: 600;\n  color: var(--sf-danger-fg-strong);\n}\n.saved-filter-confirm-actions {\n  flex: 0 0 auto;\n  display: flex;\n  gap: 4px;\n}\n.saved-filter-confirm-cancel,\n.saved-filter-confirm-confirm {\n  flex: 0 0 auto;\n  width: 1.4rem;\n  height: 1.4rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border-radius: 4px;\n  border: 1px solid;\n  cursor: pointer;\n  background: var(--sf-bg);\n  transition: background-color var(--sf-trans-fast), border-color var(--sf-trans-fast),\n              color var(--sf-trans-fast);\n}\n.saved-filter-confirm-cancel       { border-color: var(--sf-border-soft); color: var(--sf-fg-muted); }\n.saved-filter-confirm-cancel:hover { background: var(--sf-bg-hover); border-color: var(--sf-fg-faint); color: var(--sf-fg); }\n.saved-filter-confirm-confirm      { border-color: var(--sf-danger-border); color: var(--sf-danger-fg); }\n.saved-filter-confirm-confirm:hover{ background: var(--sf-danger); border-color: var(--sf-danger); color: var(--sf-bg); }\n.saved-filter-confirm-cancel i,\n.saved-filter-confirm-confirm i { font-size: .75rem; line-height: 1; }\n\n\n/* ================================================================== */\n/* Column header — title (ellipsis) + sort arrows + filter funnel     */\n/* ================================================================== */\n\n/* Every header cell shares the same height so cells without controls\n   don't collapse to a shorter line and the row bobs up and down. */\n.ajax-contents-table thead th {\n  vertical-align: middle !important;\n  height: 2.5rem;\n  line-height: 1.25;\n}\n\n/* Inner flex container: title flexes (shrinks with ellipsis), the\n   controls cluster stays fully visible on the right edge. */\n.ajax-contents-table thead th .column-header-inner {\n  display: flex;\n  align-items: center;\n  gap: .35rem;\n  width: 100%;\n  min-width: 0;\n}\n.ajax-contents-table thead th .column-title {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.ajax-contents-table thead th .column-header-controls {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n  white-space: nowrap;  /* arrows + funnel never split */\n}\n\n/* --- Column-config trigger group: trigger button + small reset --- */\n/* The wrapper is right-aligned via Bootstrap's `.float-right`; the\n   `inline-flex` here is only for the children's layout (gap between\n   trigger + reset icon). */\n.tcc-trigger-group {\n  display: inline-flex;\n  align-items: center;\n  gap: .15rem;\n}\n.tcc-reset {\n  /* Icon-only, muted; promotes to accent on hover so it reads as\n     \"secondary action\" next to the main trigger. */\n  padding: .15rem .35rem;\n  line-height: 1;\n  font-size: .85rem;\n  color: var(--sf-muted, #8a94a6);\n  text-decoration: none;\n}\n.tcc-reset:hover, .tcc-reset:focus {\n  color: var(--sf-accent, #1976d2);\n  text-decoration: none;\n}\n\n/* --- Header DnD: grip handle, grab cursor, ghost, drop indicator ---- */\n/* Sits at the trailing edge of the controls cluster (right of the\n   funnel).  Hidden by default; only the hovered or actively-dragged\n   <th> shows it.  visibility (not display) keeps the slot width\n   stable so the title doesn't reflow when the cursor enters. */\n.ajax-contents-table thead th .column-drag-handle {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  margin-left: .15rem;\n  color: var(--sf-muted, #8a94a6);\n  font-size: .8em;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity .12s ease, color .12s ease;\n  cursor: grab;\n}\n.ajax-contents-table thead th .column-drag-handle:active { cursor: grabbing; }\n.ajax-contents-table thead th:hover .column-drag-handle,\n.ajax-contents-table thead th.is-dragging .column-drag-handle {\n  opacity: .9;\n  visibility: visible;\n  color: var(--sf-accent, #1976d2);\n}\n.ajax-contents-table thead th.reorderable {\n  /* Grab cursor lives on the handle only — see .column-drag-handle\n     below — so the funnel and sort buttons keep their normal feel. */\n  position: relative;\n}\n.ajax-contents-table thead th.reorderable.is-dragging { opacity: .4; }\n\n/* Drop indicator: a 2px accent rule along the leading/trailing edge\n   of the hovered cell.  Mirrors the above/below indicator in the\n   column-config popover, just rotated 90°. */\n.ajax-contents-table thead th.is-drop-before::before,\n.ajax-contents-table thead th.is-drop-after::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background: var(--sf-accent, #1976d2);\n  pointer-events: none;\n  z-index: 2;\n}\n.ajax-contents-table thead th.is-drop-before::before { left: -1px; }\n.ajax-contents-table thead th.is-drop-after::after  { right: -1px; }\n\n/* --- Sort arrows: hidden until hover, revealed on the active col --- */\n.column-sort-arrows {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  margin-left: 0;\n  vertical-align: middle;\n  line-height: 1;\n  opacity: 0;\n  transition: opacity var(--sf-trans-fast);\n}\n.ajax-contents-table th.sortable:hover .column-sort-arrows,\n.ajax-contents-table th.active         .column-sort-arrows {\n  opacity: 1;\n}\n.column-sort-arrow {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  width: 14px;\n  height: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--sf-fg-faint);\n  font-size: .55rem;\n  border-radius: 2px;\n  transition: color var(--sf-trans-fast), background-color var(--sf-trans-fast);\n}\n.column-sort-arrow:hover  { color: var(--sf-accent); background: var(--sf-accent-overlay-08); }\n.column-sort-arrow.active { color: var(--sf-accent); }\n/* Mute the non-active arrow when one is active, so the eye reads the\n   current direction at a glance. */\n.ajax-contents-table th.active .column-sort-arrow:not(.active) {\n  color: var(--sf-border);\n}\n\n/* --- Filter funnel: hidden until hover; permanent when filtering --- */\n.ajax-contents-table th .column-filter-toggle {\n  vertical-align: middle;\n  opacity: 0;\n  transition: opacity var(--sf-trans-fast);\n}\n.ajax-contents-table th:hover         .column-filter-toggle,\n.ajax-contents-table th:focus-within  .column-filter-toggle,\n.ajax-contents-table th .column-filter-toggle.active {\n  opacity: 1;\n}\n\n\n/* ================================================================== */\n/* Column filter row — refined search strip below the header          */\n/* ================================================================== */\n.column-filter-row > td {\n  background: var(--sf-bg-subtle);\n  border-top: 1px solid var(--sf-hairline);\n  border-bottom: 1px solid var(--sf-hairline);\n  padding: .3rem .4rem;\n}\n.column-filter-row > td.empty { background: var(--sf-bg-subtle); }\n\n.column-filter-row .input-group-sm > .form-control,\n.column-filter-row .searchable-select input {\n  background: var(--sf-bg);\n  border-color: var(--sf-border-soft);\n  border-radius: 4px;\n  box-shadow: none;\n  transition: border-color var(--sf-trans-fast), box-shadow var(--sf-trans-fast);\n}\n.column-filter-row .input-group-sm > .form-control:focus,\n.column-filter-row .searchable-select input:focus {\n  border-color: var(--sf-accent-border);\n  box-shadow: 0 0 0 .15rem var(--sf-accent-overlay-15);\n}\n.column-filter-row .btn-outline-secondary {\n  background: var(--sf-bg);\n  border-color: var(--sf-border-soft);\n  color: var(--sf-fg-mutest);\n  transition: color var(--sf-trans-fast), background-color var(--sf-trans-fast),\n              border-color var(--sf-trans-fast);\n}\n.column-filter-row .btn-outline-secondary:hover {\n  background: var(--sf-bg-hover);\n  border-color: var(--sf-fg-faint);\n  color: var(--sf-fg);\n}\n\n/* ================================================================== */\n/* Table column config panel (TableColumnConfig.js)                   */\n/* Calm-clinical: drag handle on the left, eye toggle on the right,   */\n/* search + counter + bulk actions on top, hidden columns muted at    */\n/* the bottom. Drop indicator is a 2px accent line between rows.      */\n/* ================================================================== */\n\n.tcc-panel {\n  /* Portal'd to document.body. The component supplies top/left/width\n     via inline style based on the trigger's bounding rect. Fixed\n     positioning means no parent overflow can clip the panel and the\n     stacking context is the document root, so z-index works globally. */\n  position: fixed;\n  z-index: 1080;\n  max-height: 60vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--sf-bg);\n  border: 1px solid var(--sf-border-card);\n  border-radius: var(--sf-radius-card);\n  box-shadow: var(--sf-shadow-card), 0 8px 24px rgba(16,24,40,.08));\n  padding: 0;\n  font-size: .8125rem;\n  overflow: hidden;\n  animation: tccPanelIn .12s ease-out;\n}\n@keyframes tccPanelIn {\n  from { opacity: 0; transform: translateY(-4px); }\n  to   { opacity: 1; transform: translateY(0);    }\n}\n\n/* --- header --- */\n.tcc-header {\n  border-bottom: 1px solid var(--sf-hairline);\n  padding: .65rem .85rem;\n  flex: 0 0 auto;\n  background: var(--sf-bg-subtle);\n}\n.tcc-header-top {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: .5rem;\n  margin-bottom: .5rem;\n}\n.tcc-title-block { display: flex; flex-direction: column; min-width: 0; }\n.tcc-title {\n  font-size: .75rem;\n  font-weight: 600;\n  letter-spacing: .04em;\n  text-transform: uppercase;\n  color: var(--sf-fg-mutest);\n}\n.tcc-description {\n  font-size: .6875rem;\n  color: var(--sf-fg-faint);\n  font-style: italic;\n  margin-top: .15rem;\n}\n.tcc-counter {\n  flex: 0 0 auto;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: .75rem;\n  font-weight: 600;\n  color: var(--sf-fg-muted);\n  background: var(--sf-bg);\n  border: 1px solid var(--sf-hairline);\n  border-radius: 999px;\n  padding: .1rem .55rem;\n}\n.tcc-counter-sep { margin: 0 .15rem; color: var(--sf-fg-faint); }\n\n.tcc-header-tools {\n  display: flex;\n  align-items: center;\n  gap: .5rem;\n  flex-wrap: wrap;\n}\n.tcc-search { flex: 1 1 14rem; min-width: 12rem; }\n.tcc-bulk   { display: flex; gap: .35rem; flex: 0 0 auto; }\n\n/* --- body --- */\n.tcc-body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: .25rem 0 .35rem;\n}\n\n.tcc-section { padding: .25rem 0; }\n.tcc-section.is-muted { background: var(--sf-bg-subtle); }\n.tcc-section.is-muted + .tcc-section { border-top: 1px solid var(--sf-hairline); }\n.tcc-section-header {\n  display: flex;\n  align-items: baseline;\n  gap: .5rem;\n  padding: .35rem .85rem .25rem;\n}\n.tcc-section-label {\n  font-size: .6875rem;\n  font-weight: 600;\n  letter-spacing: .06em;\n  text-transform: uppercase;\n  color: var(--sf-fg-mutest);\n}\n.tcc-section-count {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: .6875rem;\n  color: var(--sf-fg-faint);\n}\n\n.tcc-empty {\n  padding: .45rem .85rem;\n  font-size: .75rem;\n  color: var(--sf-fg-empty);\n  font-style: italic;\n}\n\n/* --- list rows --- */\n.tcc-list { list-style: none; margin: 0; padding: 0; }\n\n.tcc-row {\n  display: flex;\n  align-items: center;\n  gap: .5rem;\n  padding: .25rem .85rem;\n  position: relative;\n  transition: background-color var(--sf-trans-fast);\n}\n.tcc-row + .tcc-row { border-top: 1px solid var(--sf-divider); }\n.tcc-row:hover { background: var(--sf-bg-row-hover); }\n\n.tcc-row.is-dragging { opacity: .35; }\n\n/* Drop indicator: a hairline 2px accent line above or below the\n   targeted row. Pointer-events:none so it doesn't eat the drop. */\n.tcc-row.is-drop-above::before,\n.tcc-row.is-drop-below::after {\n  content: \"\";\n  position: absolute;\n  left: .85rem;\n  right: .85rem;\n  height: 2px;\n  background: var(--sf-accent);\n  border-radius: 2px;\n  pointer-events: none;\n}\n.tcc-row.is-drop-above::before { top: -1px; }\n.tcc-row.is-drop-below::after  { bottom: -1px; }\n\n/* drag handle — only this is draggable */\n.tcc-handle {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  width: 1.4rem;\n  height: 1.4rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  color: var(--sf-fg-faint);\n  cursor: grab;\n  flex: 0 0 auto;\n}\n.tcc-handle:hover { background: var(--sf-shadow-overlay); color: var(--sf-fg-muted); }\n.tcc-handle:active { cursor: grabbing; }\n.tcc-handle i { font-size: .8125rem; }\n.tcc-handle.is-placeholder {\n  /* Hidden rows have no handle — reserve the same width for alignment. */\n  cursor: default;\n  visibility: hidden;\n}\n\n/* label */\n.tcc-label {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--sf-fg);\n}\n.tcc-section.is-muted .tcc-label { color: var(--sf-fg-muted); }\n\n/* trailing action buttons */\n.tcc-hide, .tcc-show {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  width: 1.6rem;\n  height: 1.6rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  cursor: pointer;\n  flex: 0 0 auto;\n  transition: background-color var(--sf-trans-fast),\n              color var(--sf-trans-fast);\n}\n.tcc-hide        { color: var(--sf-fg-faint); }\n.tcc-hide:hover  { color: var(--sf-fg);       background: var(--sf-shadow-overlay); }\n.tcc-show        { color: var(--sf-accent);   background: var(--sf-accent-soft); }\n.tcc-show:hover  { color: var(--sf-bg);       background: var(--sf-accent); }\n.tcc-hide i, .tcc-show i { font-size: .75rem; }\n\n/* --- footer --- */\n.tcc-footer {\n  border-top: 1px solid var(--sf-hairline);\n  padding: .45rem .85rem;\n  flex: 0 0 auto;\n  background: var(--sf-bg-subtle);\n}\n.tcc-reset {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  padding: .15rem .35rem;\n  color: var(--sf-fg-mutest);\n  font-size: .75rem;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: .35rem;\n  border-radius: 4px;\n  transition: color var(--sf-trans-fast), background-color var(--sf-trans-fast);\n}\n.tcc-reset:hover { color: var(--sf-fg); background: var(--sf-bg-hover); }\n.tcc-reset i { font-size: .7rem; }\n\n/* Column-config trigger — quiet, compact, tertiary affordance.\n   Sits flush right above the table; meant to be discoverable but\n   not loud. */\n.tcc-trigger {\n  margin: 0 0 .25rem .5rem;\n  padding: .05rem .4rem;\n  font-size: .6875rem;\n  line-height: 1.2;\n  letter-spacing: .02em;\n  color: var(--sf-fg-mutest);\n  border-color: var(--sf-hairline);\n  background: transparent;\n}\n.tcc-trigger:hover,\n.tcc-trigger:focus {\n  color: var(--sf-fg-muted);\n  border-color: var(--sf-border-soft);\n  background: var(--sf-bg-hover);\n  box-shadow: none;\n}\n.tcc-trigger i {\n  font-size: .65rem;\n  opacity: .7;\n}\n\n/* Sample label chips — rendered under Sample ID by senaite.core's\n   SamplesView.folderitem. The chip itself is a link that toggles\n   the ``?labels=<name>`` URL filter; the × button posts to\n   @@remove_label and refreshes the row. */\n.sample-id-with-labels {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: .15rem;\n}\n.sample-labels {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  gap: .2rem;\n  text-align: left;\n}\n.sample-label {\n  display: inline-flex;\n  align-items: center;\n  padding: 0 .35rem;\n  height: 1.15rem;\n  font-size: .65rem;\n  font-weight: 500;\n  line-height: 1;\n  color: var(--sf-fg-muted, #495057);\n  background: var(--sf-bg-hover, #f1f3f5);\n  border: 1px solid var(--sf-hairline, #e5e7eb);\n  border-radius: 3px;\n  text-decoration: none;\n  cursor: default;\n  transition: background-color .12s ease, color .12s ease,\n              border-color .12s ease;\n}\n.sample-label.is-filterable {\n  cursor: pointer;\n}\n.sample-label.is-filterable:hover,\n.sample-label.is-filterable:focus {\n  filter: brightness(0.95);\n  text-decoration: none;\n}\n.sample-label.active {\n  box-shadow: 0 0 0 1px var(--sf-accent, #0d6efd) inset;\n}\n.sample-label-text {\n  display: inline-block;\n}\n.sample-label-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: .25rem;\n  margin-right: -.15rem;\n  width: .8rem;\n  height: .8rem;\n  padding: 0;\n  font-size: .7rem;\n  line-height: 1;\n  color: inherit;\n  background: transparent;\n  border: 0;\n  border-radius: 2px;\n  cursor: pointer;\n  opacity: .6;\n}\n.sample-label-remove:hover,\n.sample-label-remove:focus {\n  opacity: 1;\n  background: rgba(0, 0, 0, .12);\n}\n\n\n/* Manage Labels modal — chip grid + color picker UX. */\n.manage-labels-grid {\n  margin-top: .25rem;\n}\n.manage-labels-toggle {\n  cursor: pointer;\n  opacity: .55;\n  transition: opacity .12s ease, box-shadow .12s ease;\n}\n.manage-labels-toggle:hover,\n.manage-labels-toggle:focus {\n  opacity: 1;\n}\n.manage-labels-toggle.is-selected {\n  opacity: 1;\n  box-shadow: 0 0 0 2px rgba(13, 110, 253, .35);\n}\n.manage-labels-toggle.is-removed {\n  opacity: .55;\n  text-decoration: line-through;\n  box-shadow: 0 0 0 2px rgba(220, 53, 69, .35);\n}\n.manage-labels-color {\n  flex: 0 0 2.25rem;\n  width: 2.25rem;\n  height: 2.25rem;\n  padding: 2px;\n  border: 1px solid var(--sf-border-soft, #cfd4da);\n  border-radius: .25rem;\n  background: #fff;\n  cursor: pointer;\n}\n.manage-labels-color::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n.manage-labels-color::-webkit-color-swatch {\n  border: none;\n  border-radius: 2px;\n}\n.manage-labels-color::-moz-color-swatch {\n  border: none;\n  border-radius: 2px;\n}\n.manage-labels-presets {\n  display: flex;\n  flex-wrap: wrap;\n  gap: .25rem;\n}\n.manage-labels-preset {\n  width: 1.25rem;\n  height: 1.25rem;\n  padding: 0;\n  border: 1px solid rgba(0, 0, 0, .15);\n  border-radius: 50%;\n  cursor: pointer;\n}\n.manage-labels-preset:hover,\n.manage-labels-preset:focus {\n  outline: 2px solid rgba(13, 110, 253, .35);\n}\n\n/* Larger chip variant — wraps the page <h1> on the Label view\n   (senaite.core renders the heading itself as the chip via an\n   @@title override). Sits between the row-chip body size and the\n   default H1 — readable as a heading without dominating the\n   content area. */\n.sample-label.sample-label--lg {\n  height: auto;\n  padding: .2rem .65rem;\n  font-size: 1.25rem;\n  line-height: 1.3;\n  border-radius: 5px;\n}\n.sample-label.sample-label--lg .sample-label-text {\n  font-weight: 500;\n}\n\n/* Active label filter chips, rendered above-right of the listing,\n   immediately before the search box. The × removes the filter from\n   the page URL. */\n.active-label-filters {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: .25rem;\n  margin-right: .5rem;\n}\n.active-label-filter {\n  display: inline-flex;\n  align-items: center;\n  /* Compact pill — deliberately smaller than the form-control-sm\n     search box next to it so the chip reads as a status indicator\n     riding alongside the input, not as a peer button. align-items:\n     center on the parent flex row keeps the chip mid-line with the\n     search box. */\n  height: 1.6rem;\n  padding: 0 .35rem 0 .6rem;\n  /* Default to the row-chip neutral palette so a Label with no\n     color shows the same grey pill in both places. When the\n     listing controller resolves the per-label color it sets an\n     inline style that wins over these fallbacks. */\n  color: var(--sf-fg-muted, #495057);\n  background: var(--sf-bg-hover, #f1f3f5);\n  border: 1px solid var(--sf-hairline, #e5e7eb);\n  border-radius: 3px;\n  font-size: .75rem;\n  font-weight: 500;\n  line-height: 1;\n}\n.active-label-filter__name {\n  display: inline-block;\n}\n.active-label-filter__remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: .35rem;\n  width: 1rem;\n  height: 1rem;\n  padding: 0;\n  font-size: .85rem;\n  line-height: 1;\n  color: inherit;\n  background: transparent;\n  border: 0;\n  border-radius: 2px;\n  cursor: pointer;\n  opacity: .7;\n}\n.active-label-filter__remove:hover,\n.active-label-filter__remove:focus {\n  opacity: 1;\n  background: rgba(0, 0, 0, .08);\n}\n\n/* Active column filters indicator, shown on the right of the column\n   config row so the user is aware the listing is narrowed down. */\n.listing-table-toolbar {\n  margin-bottom: .5rem;\n}\n.listing-table-toolbar__right {\n  display: inline-flex;\n  align-items: center;\n}\n.active-column-filters {\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: .25rem;\n}\n.active-column-filter {\n  display: inline-flex;\n  align-items: center;\n  padding: 0 .35rem 0 .6rem;\n  color: var(--sf-fg-muted, #495057);\n  background: var(--sf-bg-hover, #f1f3f5);\n  border: 1px solid var(--sf-hairline, #e5e7eb);\n  border-radius: 3px;\n  font-size: .75rem;\n  font-weight: 500;\n  line-height: 1.6rem;\n}\n.active-column-filter__remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: .35rem;\n  width: 1rem;\n  height: 1rem;\n  padding: 0;\n  font-size: .85rem;\n  line-height: 1;\n  color: inherit;\n  background: transparent;\n  border: 0;\n  border-radius: 2px;\n  cursor: pointer;\n  opacity: .7;\n}\n.active-column-filter__remove:hover,\n.active-column-filter__remove:focus {\n  opacity: 1;\n  background: rgba(0, 0, 0, .08);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
